/* Kandes Wall Planner - PARTNER EDITION. Engine ported 1:1 from the Kandes store
   planner (approved UX prototype v0.12); self-contained vanilla JS, no theme.js
   dependencies. Quote requests submit through the HOST STORE'S native Shopify
   contact form - no external gateway, leads stay with the store hosting this file.
   Analytics event: planner_quote_request (fires into the host store's dataLayer).
   One planner instance per page.
   (c) Kandes GmbH. Licensed for use in authorised partner stores; do not edit
   below the settings surface - see CLAUDE-HANDOFF.md in the partner pack. */
(function(){
"use strict";
function init(){
var ROOT = document.getElementById("KandesWallPlanner");
if(!ROOT || ROOT.getAttribute("data-kwp-ready")) return;
ROOT.setAttribute("data-kwp-ready","1");

var IMG = window.KWP_TILES || {};
var CONTACT_EMAIL = ROOT.getAttribute("data-kwp-contact-email") || "";
var LOCALE = ROOT.getAttribute("data-kandes-locale") || "en";

function tileUse(imgKey, fx, fy, fw, fh){
  return `<svg x="${fx}" y="${fy}" width="${fw}" height="${fh}" viewBox="0 0 100 100" preserveAspectRatio="none"><use href="#im-${imgKey}"/></svg>`;
}
function imgDefs(list){
  return [...new Set(list)].filter(im=>IMG[im]).map(im=>`<image id="im-${im}" href="${IMG[im]}" width="100" height="100" preserveAspectRatio="none"/>`).join("");
}

/* =============== Panel orientation (AQUA/CURVE/INCA/ORIGAMI) ===============
   These panels are non-square and can be placed either way. `photo` = the
   orientation the tile was shot in ("h" long-side-horizontal, "v" long-side-
   vertical); when the chosen orientation differs, the tile is rendered in a box
   of its native aspect and rotated 90° so it never stretches. `def` = default. */
const ORIENT = {
  "0018": {long:1.0, short:0.2,  photo:"h", def:"v"},  // AQUA  — 100×20 strip
  "0085": {long:1.0, short:0.2,  photo:"h", def:"v"},  // CURVE — 100×20 strip
  "0024": {long:0.5, short:0.25, photo:"h", def:"h"},  // ORIGAMI — 50×25
  "0053": {long:0.5, short:0.4,  photo:"h", def:"h"},  // FOAM — 50×40 (photo landscape)
  "0082": {long:0.2, short:0.1,  photo:"v", def:"v"}   // INCA — 20×10 mosaic piece
};
function orientCfg(m){ return m && ORIENT[m.sku]; }
/* Effective cell geometry for the active orientation. Returns null for models
   that don't support orientation (so callers fall back to m.w/m.h). */
function effOrient(m){
  const c=orientCfg(m); if(!c) return null;
  const o=S.orient || c.def;                          // "h" | "v"
  return { w: o==="h"? c.long : c.short,
           h: o==="h"? c.short : c.long,
           rot90: o!==c.photo,                        // tile turned 90° vs its photo
           o };
}
function effW(m){ const e=effOrient(m); return e? e.w : (m? m.w : 0); }
function effH(m){ const e=effOrient(m); return e? e.h : (m? m.h : 0); }
/* Draw a tile filling a cell without ever stretching the photo. `rot90` renders
   it in a transposed (native-aspect) box turned 90°; `steps` (0..3) is the
   customer's manual flip on top. */
function orientedTile(tk, fx, fy, fw, fh, rot90, steps){
  const cx=fx+fw/2, cy=fy+fh/2;
  const deg=(((rot90?1:0)+(steps||0))%4)*90;
  if(!rot90){
    return `<g${deg?` transform="rotate(${deg} ${cx} ${cy})"`:""}>`+tileUse(tk, fx, fy, fw, fh)+`</g>`;
  }
  // Transposed box (aspect = the photo's), centred on the cell, then rotated.
  return `<g transform="rotate(${deg} ${cx} ${cy})">`+tileUse(tk, cx-fh/2, cy-fw/2, fh, fw)+`</g>`;
}

/* =============== Models =============== */
const TRI_SKUS = [
  {sku:"0121", tile:"tr0121"},
  {sku:"0221", tile:"tr0221"},
  {sku:"0321", tile:"tr0321"}
];
const SPECIAL_MODELS = [
  {id:"waves",   sku:"0058", kind:"grid", name:"WAVES 0058",         w:.5,h:.5, kg:4,  pkg:3, tile:"0058", imgs:["0058"]},
  {id:"surf",    sku:"0077", kind:"surfrip", name:"SURF 0077", w:.5,h:.5, kg:3, setSize:4, partner:"ripple", tiles:["surf1","surf2","surf3","surf4"], block:{cols:2, rows:2, map:[0,1,2,3]}},
  {id:"ripple",  sku:"0076", kind:"surfrip", name:"RIPPLE 0076", w:.5,h:.5, kg:3, setSize:2, partner:"surf", tiles:["rip1","rip2"], block:{cols:2, rows:1, map:[0,1]}},
  {id:"grid",    sku:"0015", kind:"grid", name:"GRID + LED 0015",    w:.5,h:.5, kg:3.5,pkg:3, tile:"t15", led:"optional", acc:{profile:{len:1.5,label:"LED profile (150 cm)"}}, imgs:["t15"]},
  {id:"cascade", sku:"0114", kind:"grid", name:"CASCADE + LED 0114", w:.5,h:.5, kg:3.5,pkg:3, tile:"t114", led:"optional", acc:{profile:{len:1.5,label:"LED profile (150 cm)"}}, imgs:["t114"]},
  {id:"ligneo",  sku:"0112", kind:"grid", name:"LIGNEO + LED 0112",  w:.5,h:.5, kg:5,  pkg:1, tile:"t112", led:"optional", acc:{profile:{len:1.5,label:"Aluminium LED profile (150 cm)"},projector:{label:"LED projector (mounts on profile)"}}, imgs:["t112"]},
  {id:"futur",   sku:"0042", kind:"grid", name:"FUTUR + LED 0042",   w:.5,h:.5, kg:3,  pkg:2, tileAB:["futA","futB"], led:"integrated", aluAll:true, defaultFill:"full", swap:true, imgs:["futA","futB"]},
  {id:"slate",   sku:"0073", kind:"grid", name:"SLATE + LED 0073",   w:.6,h:.3, kg:4,  pkg:2, tile:"slate", led:"integrated", set2:true, swap:true, offable:true, imgs:["slate"]},
  {id:"cosmic",  sku:"0012", kind:"cosmic", name:"COSMIC 0012 — modular", cell:.3, imgs:["cled","cplain"],
    skus:[{id:"0012",label:"Large 60×60 · LED", s:2, led:true,  kg:5,   tile:"cled"},
          {id:"0312",label:"Large 60×60",       s:2, led:false, kg:5,   tile:"cplain"},
          {id:"0212",label:"Medium 30×30 · LED",s:1, led:true,  kg:2.5, tile:"cled"},
          {id:"0412",label:"Medium 30×30",      s:1, led:false, kg:2.5, tile:"cplain"}]},
  {id:"trinity", sku:"0021", kind:"trinity", name:"TRINITY + LED 0021 — modular", w:.5,h:.5, kg:3.8, led:"integrated", swap:true, imgs:["tr0121","tr0221","tr0321"]},
  {id:"hex",     sku:"0045", kind:"hex", name:"HEXAGON + LED 0045",  w:.35,h:.3, cov:.08, kg:3, pkg:2, set2:true, led:"integrated", defaultFill:"full", imgs:["hexA","hexB"]}
];
const MODELS = SPECIAL_MODELS.concat(
  (window.KWP_STANDARD_MODELS||[]).map(d=>({
    id:d.sku, sku:d.sku, kind:d.kind||"grid", name:d.name+" "+d.sku,
    w:d.w, h:d.h, kg:d.kg, pkg:d.pkg, cov:d.cov,
    tile:d.tile, tiles:d.tiles, setCols:d.setCols,
    transparent:d.transparent, step:d.step, led:d.led,
    // CRITICAL: <defs> images are built ONLY from m.imgs, so derive it from
    // tile/tiles here or every photo renders blank (Novelties handoff N1).
    imgs: d.tiles ? d.tiles.slice() : (d.tile ? [d.tile] : [])
  }))
).sort((a,b)=>a.name.localeCompare(b.name));
const COSMIC_KG = {"0012":5,"0312":5,"0212":2.5,"0412":2.5};

/* =============== State =============== */
const S = {
  model: MODELS.find(m=>m.id==="waves") || MODELS[0],
  walls: [ newWall(3.6, 2.5) ],
  active: 0,
  skirt: 0,
  alignH:"center", alignV:"bottom",
  fillMode:"fill",
  spill:true,
  accProfiles:0, accProjectors:0,
  triExtra:0,
  warmA:"6000K", warmB:null, compare:false,
  orient:null,
  seg:"private"
};
function newWall(w,h){ return {w:w||"",h:h||"",open:[],
  cosmic:{counts:{"0012":0,"0312":0,"0212":0,"0412":0},placed:null,fillEdges:false,fillSku:"0412"},
  futArr:{}, triArr:{}, slateArr:{}, slateOff:{}, hexArr:{}, hexOff:{},
  // Universal per-cell maps (Novelties N3/N4/N6/N7): rotation, set-piece override,
  // and per-column step offset. Keyed "c,r" (rot/setArr) or column index (stepOff).
  // MUST be cleared wherever the cell grid re-indexes (see clearCellMaps + handlers).
  rot:{}, setArr:{}, stepOff:{}, mosaicArr:{},
  sr:{combine:false, mainSets:null, partnerSets:null, arr:{}, rot:{}}}; }
/* Reset the "c,r"-keyed cell maps — call on any geometry change (resize / skirt /
   align / openings) that re-indexes the grid, mirroring how sr.arr/rot are reset. */
function clearCellMaps(w){ w.rot={}; w.setArr={}; w.stepOff={}; w.mosaicArr={}; }
const modelById = id => MODELS.find(x=>x.id===id);

/* ?model=<sku> deep link from product pages — piece/size SKUs map to their modular entry */
(function(){
  var pre;
  try{ pre = new URLSearchParams(window.location.search).get("model"); }catch(e){ return; }
  if(!pre) return;
  pre = pre.trim();
  var alias = {"0312":"0012","0212":"0012","0412":"0012","0121":"0021","0221":"0021","0321":"0021","0421":"0021"};
  var target = MODELS.find(function(m){ return (m.sku||"")===pre; })
    || MODELS.find(function(m){ return (m.sku||"")===(alias[pre]||"—"); })
    || MODELS.find(function(m){ return m.name.toLowerCase().indexOf(pre.toLowerCase())>=0; });
  if(target){ S.model = target; S.fillMode = target.defaultFill || "fill"; }
})();

/* =============== Shareable walls (10 Jul 2026 — Website Architecture play #1) ===
   The full planner state serializes into the URL fragment (#w=<base64url JSON>),
   so every designed wall has its own link: no backend, no storage, survives
   worker outages. restoreFromFragment() runs AFTER the ?model deep link above so
   a shared wall always wins over the plain model preselect. Unknown/invalid
   fragments fall back to the default state (never break the planner). */
function kwpB64Encode(str){
  return btoa(unescape(encodeURIComponent(str))).replace(/\+/g,"-").replace(/\//g,"_").replace(/=+$/,"");
}
function kwpB64Decode(s){
  s=s.replace(/-/g,"+").replace(/_/g,"/"); while(s.length%4) s+="=";
  return decodeURIComponent(escape(atob(s)));
}
function kwpNum(v,lo,hi){ v=+v; return Number.isFinite(v)? Math.min(Math.max(v,lo),hi) : 0; }
function kwpCopyMap(src,fn){
  var out={};
  if(src && typeof src==="object" && !Array.isArray(src)){
    Object.keys(src).slice(0,600).forEach(function(k){
      var v=fn(src[k]);
      if(v!==undefined) out[String(k).slice(0,12)]=v;
    });
  }
  return out;
}
/* Short keys keep typical links a few hundred characters; per-cell maps are only
   included when the customer actually rearranged something. */
var KWP_WALL_MAPS=[["fA","futArr"],["tA","triArr"],["sA","slateArr"],["sO","slateOff"],
  ["hA","hexArr"],["hO","hexOff"],["rt","rot"],["st","setArr"],["so","stepOff"],["mA","mosaicArr"]];
function serializeState(){
  var d={v:1, m:S.model.id, fm:S.fillMode};
  if(S.orient) d.o=S.orient;
  if(S.skirt) d.k=S.skirt;
  if(S.alignH!=="center") d.ah=S.alignH;
  if(S.alignV!=="bottom") d.av=S.alignV;
  if(!S.spill) d.ns=1;
  if(S.accProfiles) d.ap=S.accProfiles;
  if(S.accProjectors) d.aj=S.accProjectors;
  if(S.triExtra) d.tx=S.triExtra;
  if(S.warmA!=="6000K") d.wa=S.warmA;
  if(S.compare){ d.cmp=1; d.wb=S.warmB||"3000K"; }
  if(S.active) d.a=S.active;
  d.W=S.walls.map(function(w){
    var e={w:+w.w||0, h:+w.h||0};
    if(w.open.length) e.op=w.open.map(function(o){ return [o.x,o.y,o.w,o.h]; });
    KWP_WALL_MAPS.forEach(function(mk){
      var src=w[mk[1]];
      if(src && Object.keys(src).length) e[mk[0]]=src;
    });
    var c=w.cosmic;
    if(c && (c.counts["0012"]||c.counts["0312"]||c.counts["0212"]||c.counts["0412"]||c.fillEdges)){
      e.cm={n:c.counts};
      if(c.fillEdges){ e.cm.f=1; e.cm.fs=c.fillSku; }
      if(c.placed && c.placed.list && c.placed.list.length){
        e.cm.p={k:c.placed.key, m:c.placed.misfit||0,
                l:c.placed.list.map(function(t){ return [t.sku,t.c,t.r,t.s]; })};
      }
    }
    var sr=w.sr;
    if(sr && (sr.combine || Object.keys(sr.arr).length || Object.keys(sr.rot).length)){
      e.sr={};
      if(sr.combine){ e.sr.c=1; e.sr.ms=sr.mainSets; e.sr.ps=sr.partnerSets; }
      if(Object.keys(sr.arr).length) e.sr.a=sr.arr;
      if(Object.keys(sr.rot).length) e.sr.r=sr.rot;
    }
    return e;
  });
  return d;
}
function buildShareUrl(){
  return location.origin+location.pathname+"#w="+kwpB64Encode(JSON.stringify(serializeState()));
}
function restoreFromFragment(){
  try{
    var mm=(window.location.hash||"").match(/[#&]w=([A-Za-z0-9_-]+)/);
    if(!mm) return false;
    var d=JSON.parse(kwpB64Decode(mm[1]));
    if(!d || d.v!==1 || !Array.isArray(d.W) || !d.W.length) return false;
    var m=modelById(String(d.m||"")); if(!m) return false;
    var iv=function(max){ return function(v){ v=+v; return Number.isFinite(v)&&v>=0&&v<=max ? Math.round(v) : undefined; }; };
    var bv=function(v){ return !!v; };
    var so=function(v){ v=+v; return Number.isFinite(v)&&v>=0&&v<=0.75 ? Math.round(v/0.25)*0.25 : undefined; };
    var mapFns={fA:iv(1), tA:iv(2), sA:bv, sO:bv, hA:bv, hO:bv, rt:iv(3), st:iv(3), so:so, mA:iv(17)};
    S.model=m;
    S.fillMode = d.fm==="full" ? "full" : "fill";
    S.orient = orientCfg(m) ? ((d.o==="h"||d.o==="v")? d.o : orientCfg(m).def) : null;
    S.skirt = kwpNum(d.k,0,30);
    S.alignH = ["left","center","right"].indexOf(d.ah)>=0 ? d.ah : "center";
    S.alignV = ["top","center","bottom"].indexOf(d.av)>=0 ? d.av : "bottom";
    S.spill = !d.ns;
    S.accProfiles = Math.round(kwpNum(d.ap,0,999));
    S.accProjectors = Math.round(kwpNum(d.aj,0,999));
    S.triExtra = Math.round(kwpNum(d.tx,0,999));
    var warms=["6000K","4000K","3000K","RGB"];
    S.warmA = warms.indexOf(d.wa)>=0 ? d.wa : "6000K";
    S.compare = !!d.cmp;
    S.warmB = S.compare ? (warms.indexOf(d.wb)>=0 ? d.wb : "3000K") : null;
    S.walls = d.W.slice(0,8).map(function(e){
      e = (e && typeof e==="object" && !Array.isArray(e)) ? e : {};
      var w=newWall(kwpNum(e.w,0,30)||"", kwpNum(e.h,0,8)||"");
      (Array.isArray(e.op)? e.op.slice(0,3):[]).forEach(function(o){
        if(!Array.isArray(o)) return;
        var op={x:kwpNum(o[0],0,30), y:kwpNum(o[1],0,8), w:kwpNum(o[2],0.2,30), h:kwpNum(o[3],0.2,8)};
        clampOpening(w,op); w.open.push(op);
      });
      KWP_WALL_MAPS.forEach(function(mk){
        if(e[mk[0]]) w[mk[1]]=kwpCopyMap(e[mk[0]], mapFns[mk[0]]);
      });
      if(e.cm && typeof e.cm==="object"){
        var cn=e.cm.n||{};
        ["0012","0312","0212","0412"].forEach(function(k){ w.cosmic.counts[k]=Math.round(kwpNum(cn[k],0,400)); });
        w.cosmic.fillEdges = !!e.cm.f;
        w.cosmic.fillSku = e.cm.fs==="0312" ? "0312" : "0412";
        if(e.cm.p && typeof e.cm.p==="object" && Array.isArray(e.cm.p.l)){
          var list=[];
          e.cm.p.l.slice(0,800).forEach(function(tt){
            if(!Array.isArray(tt)) return;
            var sku=String(tt[0]);
            if(["0012","0312","0212","0412"].indexOf(sku)<0) return;
            list.push({sku:sku, c:Math.round(kwpNum(tt[1],0,200)), r:Math.round(kwpNum(tt[2],0,200)),
                       s:(sku==="0012"||sku==="0312")?2:1});
          });
          // packCosmic() validates the key against the restored counts + grid and
          // silently re-packs if the wall no longer matches — never breaks.
          if(list.length) w.cosmic.placed={key:String(e.cm.p.k||""), list:list, misfit:Math.round(kwpNum(e.cm.p.m,0,999))};
        }
      }
      if(e.sr && typeof e.sr==="object"){
        w.sr.combine = !!e.sr.c;
        if(w.sr.combine){
          w.sr.mainSets = (e.sr.ms===null||e.sr.ms===undefined) ? null : Math.round(kwpNum(e.sr.ms,0,400));
          w.sr.partnerSets = (e.sr.ps===null||e.sr.ps===undefined) ? null : Math.round(kwpNum(e.sr.ps,0,400));
        }
        w.sr.arr = kwpCopyMap(e.sr.a, function(v){
          if(v===null) return null;
          if(v && typeof v==="object" && modelById(v.mo)) return {mo:v.mo, i:Math.round(kwpNum(v.i,0,7))};
          return undefined;
        });
        w.sr.rot = kwpCopyMap(e.sr.r, iv(3));
      }
      return w;
    });
    S.active = Math.min(Math.max(0, Math.round(kwpNum(d.a,0,7))), S.walls.length-1);
    return true;
  }catch(err){ return false; }
}
restoreFromFragment();

const $ = id => document.getElementById(id);
const wallLetter = i => String.fromCharCode(65+i);

/* =============== Geometry helpers =============== */
function band(wall){
  const H = +wall.h||0, sk = S.skirt/100;
  return {top:0, bottom:Math.max(0,H-sk), W:+wall.w||0, H, usable:Math.max(0,H-sk)};
}
function overlap(ax,ay,aw,ah,b){
  const ix = Math.min(ax+aw,b.x+b.w)-Math.max(ax,b.x);
  const iy = Math.min(ay+ah,b.y+b.h)-Math.max(ay,b.y);
  return (ix>0&&iy>0)? ix*iy : 0;
}
function openingState(cell, wall){
  let st="none";
  for(const o of wall.open){
    const a = overlap(cell.x,cell.y,cell.w,cell.h,o);
    if(a<=0.0004) continue;
    if(a >= cell.w*cell.h - 0.0004) return "inside";
    st="cut";
  }
  return st;
}
function openArea(wall){ return wall.open.reduce((a,o)=>a+Math.max(0,o.w*o.h),0); }

/* =============== Engines =============== */
function cellsGrid(wall, m){
  const b = band(wall);
  const full = S.fillMode==="full";
  const mw=effW(m), mh=effH(m);                        // orientation-aware (ORIGAMI)
  if(b.W < mw*(full?1:0.5) || b.usable < mh*(full?1:0.5)) return null;
  const cols = full? Math.floor(b.W/mw) : Math.ceil(b.W/mw);
  const rows = full? Math.floor(b.usable/mh) : Math.ceil(b.usable/mh);
  if(cols<1||rows<1) return null;
  const ox = S.alignH==="left"?0 : S.alignH==="right"? b.W-cols*mw : (b.W-cols*mw)/2;
  const oy = S.alignV==="top"? b.top : S.alignV==="center"? b.top+(b.usable-rows*mh)/2 : b.bottom-rows*mh;
  const cells=[];
  for(let r=0;r<rows;r++) for(let c=0;c<cols;c++){
    const cell={x:ox+c*mw, y:oy+r*mh, w:mw, h:mh, c, r};
    const edgeCut = !full && (cell.x<-0.004 || cell.y<b.top-0.004 || cell.x+cell.w>b.W+0.004 || cell.y+cell.h>b.bottom+0.004);
    const os = openingState(cell, wall);
    if(os==="inside") continue;
    if(full && os==="cut") continue;
    cell.cut = edgeCut || (!full && os==="cut");
    cells.push(cell);
  }
  if(!cells.length) return null;
  if(m.offable) cells.forEach(c=>{ c.off = !!wall.slateOff[c.c+","+c.r]; });
  if(m.set2){
    const act = cells.filter(c=>!c.off);
    const target = Math.floor(act.length/2);
    let given=0;
    act.forEach(c=>{ if(!c.cut && given<target){ c.led=true; given++; } });
    act.forEach(c=>{ const k=c.c+","+c.r; if(wall.slateArr[k]!==undefined) c.led=wall.slateArr[k]; });
  } else if(m.led==="integrated"){ cells.forEach(c=>c.led=true); }
  return {cells, full, cols, rows};
}

function hexCells(wall, m){
  const b=band(wall); const hw=m.w, hh=m.h, dx=hw*0.75;
  if(b.W<hw || b.usable<hh) return null;
  const full=S.fillMode==="full";
  const cols=Math.ceil(b.W/dx)+1, rows=Math.ceil(b.usable/hh)+1;
  const cells=[];
  for(let c=0;c<cols;c++) for(let r=0;r<rows;r++){
    const cx=c*dx+hw/2;
    const cy=b.bottom - r*hh - (c%2?hh/2:0) - hh/2;
    if(cx-hw/2>=b.W-0.004||cx+hw/2<=0.004||cy-hh/2>=b.bottom-0.004||cy+hh/2<=b.top+0.004) continue;
    const inside = cx-hw/2>=-0.004 && cx+hw/2<=b.W+0.004 && cy-hh/2>=b.top-0.004 && cy+hh/2<=b.bottom+0.004;
    if(full && !inside) continue;
    const os=openingState({x:cx-hw/2,y:cy-hh/2,w:hw,h:hh}, wall);
    if(os==="inside") continue;
    if(os==="cut" && full) continue;
    const cell={c,r,cx,cy,w:hw,h:hh,cut:(!inside)||(os==="cut"),key:c+","+r};
    cell.off=!!wall.hexOff[cell.key];
    cells.push(cell);
  }
  if(!cells.length) return null;
  const act=cells.filter(x=>!x.off);
  const target=Math.floor(act.length/2);
  let given=0;
  act.forEach(x=>{ if(!x.cut && given<target){ x.led=true; given++; } });
  act.forEach(x=>{ if(wall.hexArr[x.key]!==undefined) x.led=wall.hexArr[x.key]; });
  return {cells, act};
}

function cellsCosmic(wall, m){
  const b = band(wall), cs = m.cell;
  const cols=Math.floor(b.W/cs), rows=Math.floor(b.usable/cs);
  if(cols<1||rows<1) return null;
  const gw=cols*cs, gh=rows*cs;
  const ox = S.alignH==="left"?0 : S.alignH==="right"? b.W-gw : (b.W-gw)/2;
  const oy = S.alignV==="top"? b.top : S.alignV==="center"? b.top+(b.usable-gh)/2 : b.bottom-gh;
  const grid=[]; let free=0;
  for(let r=0;r<rows;r++){ grid[r]=[];
    for(let c=0;c<cols;c++){
      const cell={x:ox+c*cs,y:oy+r*cs,w:cs,h:cs};
      const blocked = openingState(cell,wall)!=="none";
      grid[r][c] = blocked? "blocked":"free";
      if(!blocked) free++;
    }
  }
  const stripArea = Math.max(0, b.W*b.usable - openArea(wall) - free*cs*cs);
  return {grid, cols, rows, ox, oy, cs, free, stripArea, b};
}
function packCosmic(wall, m){
  const g = cellsCosmic(wall,m); if(!g) return null;
  const st = wall.cosmic;
  const key = JSON.stringify(st.counts)+"|"+g.cols+"x"+g.rows;
  if(st.placed && st.placed.key===key) return {g, placed:st.placed.list, misfit:st.placed.misfit};
  const occ = g.grid.map(r=>r.map(v=>v!=="free"));
  const placed=[]; let misfit=0;
  const wanted=[];
  ["0012","0312"].forEach(k=>{ for(let i=0;i<(st.counts[k]||0);i++) wanted.push(k); });
  ["0212","0412"].forEach(k=>{ for(let i=0;i<(st.counts[k]||0);i++) wanted.push(k); });
  for(const k of wanted){
    const sz=(k==="0012"||k==="0312")?2:1;
    let done=false;
    for(let r=0;r<=g.rows-sz && !done;r++) for(let c=0;c<=g.cols-sz && !done;c++){
      let ok=true;
      for(let dr=0;dr<sz;dr++) for(let dc=0;dc<sz;dc++) if(occ[r+dr][c+dc]) ok=false;
      if(ok){ for(let dr=0;dr<sz;dr++) for(let dc=0;dc<sz;dc++) occ[r+dr][c+dc]=true;
        placed.push({sku:k,c,r,s:sz}); done=true; }
    }
    if(!done) misfit++;
  }
  st.placed={key, list:placed, misfit};
  return {g, placed, misfit};
}
function cosmicFillCount(wall, m){
  if(!wall.cosmic.fillEdges) return 0;
  const g=cellsCosmic(wall,m); if(!g) return 0;
  const cov = wall.cosmic.fillSku==="0312"? .36 : .09;
  return Math.ceil(g.stripArea/cov);
}

function cellsTrinity(wall, m){
  const base = cellsGrid(wall, {w:.5,h:.5}); if(!base) return null;
  base.cells.forEach((c,i)=>{
    const k=c.c+","+c.r;
    c.idx = wall.triArr[k]!==undefined ? wall.triArr[k] : i%3;
    c.def = TRI_SKUS[c.idx];
  });
  return {cells:base.cells, total:base.cells.length, full:base.full};
}

function cellsSurfRip(wall, m){
  const base = cellsGrid(wall, {w:.5,h:.5}); if(!base) return null;
  const st = wall.sr;
  const partner = modelById(m.partner);
  const cells = base.cells;
  let defaults = [];
  if(st.combine){
    if(st.mainSets===null) st.mainSets = Math.max(1, Math.floor(cells.length/(m.setSize+partner.setSize)));
    if(st.partnerSets===null) st.partnerSets = Math.max(1, Math.floor(cells.length/(m.setSize+partner.setSize)));
    const rounds = Math.max(st.mainSets, st.partnerSets);
    for(let s=0;s<rounds;s++){
      if(s<st.mainSets) for(let i=0;i<m.setSize;i++) defaults.push({mo:m.id, i});
      if(s<st.partnerSets) for(let i=0;i<partner.setSize;i++) defaults.push({mo:partner.id, i});
    }
  } else {
    defaults = cells.map(c=>({mo:m.id, i:m.block.map[(c.r%m.block.rows)*m.block.cols + (c.c%m.block.cols)]}));
  }
  cells.forEach((c,i)=>{
    const k=c.c+","+c.r;
    c.assign = (k in st.arr) ? st.arr[k] : (i<defaults.length ? defaults[i] : null);
    c.rot = st.rot[k]||0;
  });
  const assigned = cells.filter(c=>c.assign);
  return {cells, full:base.full, assigned, poolSize:defaults.length};
}

function countAreaModel(wall, m){
  const b=band(wall);
  const area = Math.max(0, b.W*b.usable - openArea(wall));
  if(area < m.cov) return null;
  return {area, n:Math.ceil(area/m.cov)};
}

/* =============== Totals + per-wall breakdown =============== */
function totals(){
  const m=S.model;
  let n=0, cut=0, valid=false, area=0, kg=0, offN=0, srMain=0, srPart=0, srUnplaced=0, srPainted=0;
  const perWall=[];
  S.walls.forEach((wall,i)=>{
    const b=band(wall);
    const wa = (b.W>0&&b.usable>0)? Math.max(0,b.W*b.usable-openArea(wall)) : 0;
    let entry=null;
    if(m.kind==="grid"){
      const r = m.step ? cellsStep(wall,m) : cellsGrid(wall,m);
      if(r){ const act=r.cells.filter(x=>!x.off);
        const c=act.filter(x=>x.cut).length, oN=r.cells.length-act.length;
        n+=act.length; cut+=c; offN+=oN; valid=true; area+=wa;
        entry=`${act.length} ${m.step?"strips":"pcs"}${c?` · ${c} cut`:""}${oN?` · ${oN} left out`:""}${r.full?" · full panels":""}`; }
    } else if(m.kind==="area"){
      const r=countAreaModel(wall,m);
      if(r){ n+=r.n; valid=true; area+=wa; entry=`${r.n} pcs (by covered area)`; }
    } else if(m.kind==="cosmic"){
      const p=packCosmic(wall,m);
      if(p){ valid=true; area+=wa;
        const c=wall.cosmic.counts, fc=cosmicFillCount(wall,m);
        n += c["0012"]+c["0312"]+c["0212"]+c["0412"]+fc; cut+=fc;
        Object.keys(c).forEach(k=>{ kg+=c[k]*COSMIC_KG[k]; });
        kg += fc*COSMIC_KG[wall.cosmic.fillSku];
        entry = ["0012","0312","0212","0412"].filter(k=>c[k]).map(k=>`${k}×${c[k]}`).join(" · ")||"—";
        if(fc) entry+=` · +${fc} cut fill`; }
    } else if(m.kind==="trinity"){
      const r=cellsTrinity(wall,m);
      if(r){ const c=r.cells.filter(x=>x.cut).length;
        n+=r.total; cut+=c; valid=true; area+=wa;
        entry=`${r.total} squares${c?` · ${c} cut`:""}${r.full?" · full panels":""}`; }
    } else if(m.kind==="hex"){
      const r=hexCells(wall,m);
      if(r){ const nAct=r.act.length, cc=r.act.filter(x=>x.cut).length, oN=r.cells.length-nAct;
        n+=nAct; cut+=cc; offN+=oN; valid=true; area+=wa;
        entry=`${nAct} pcs${cc?` · ${cc} cut`:""}${oN?` · ${oN} left out`:""}${S.fillMode==="full"?" · full hexagons":""}`; }
    } else if(m.kind==="surfrip"){
      const r=cellsSurfRip(wall,m);
      if(r){ valid=true; area+=wa;
        const st=wall.sr, partner=modelById(m.partner);
        cut += r.assigned.filter(x=>x.cut).length;
        if(st.combine){
          const mainN=st.mainSets*m.setSize, partN=st.partnerSets*partner.setSize;
          n += mainN+partN; srMain+=st.mainSets; srPart+=st.partnerSets;
          if(r.poolSize>r.cells.length) srUnplaced += r.poolSize-r.cells.length;
          if(r.cells.length>r.poolSize) srPainted += r.cells.length-r.poolSize;
          entry=`${m.name.split(" ")[0]} ${st.mainSets}×${m.setSize} · ${partner.name.split(" ")[0]} ${st.partnerSets}×${partner.setSize}`;
        } else {
          const sets=Math.ceil(r.cells.length/m.setSize);
          n += sets*m.setSize; srMain+=sets;
          entry=`${r.cells.length} pcs (${sets} sets of ${m.setSize})${r.full?" · full panels":""}`;
        }
      }
    }
    if(entry) perWall.push({label:"Wall "+wallLetter(i), txt:entry});
  });
  if(m.set2) n=Math.ceil(n/2)*2;
  const spillN = S.spill && n>0 ? Math.ceil(n*0.05) : 0;
  let gross=n+spillN, pkgs=gross, finalN=gross;
  if(m.kind==="trinity"){ pkgs=Math.ceil(gross/3); finalN=pkgs*3; }
  else if(m.pkg>1){ pkgs=Math.ceil(gross/m.pkg); finalN=pkgs*m.pkg; }
  if(m.kind!=="cosmic") kg=finalN*(m.kg||0); else kg=kg*(1+(S.spill?0.05:0));
  return {n,cut,spillN,gross,pkgs,finalN,valid,area,kg:Math.round(kg),perWall,offN,srMain,srPart,srUnplaced,srPainted};
}

/* =============== STEP grid (AQUA 0018 & CURVE 0085 — N7) ===============
   step:true on a kind:"grid" model. 1.0 m columns, each a stack of 0.20 m strips.
   Each column's stack starts at a vertical offset = 0.25×(col mod 4) m by default
   (overridable via wall.stepOff[col], snapped to 0/0.25/0.50/0.75 on vertical drag),
   giving the rising diagonal staircase. Full mode: whole strips only, offset gaps
   stay painted. Fill mode: partial edge strips are cut. Count = strips per column. */
function stepOffset(wall, m, col){
  const raw = wall.stepOff[col];
  return raw!==undefined ? raw : 0.25*(((col%4)+4)%4);
}
function cellsStep(wall, m){
  const b=band(wall), full=S.fillMode==="full";
  const W=b.W, U=b.usable, cw=effW(m), ch=effH(m);     // orientation-aware (AQUA/CURVE)
  if(W < cw*(full?1:0.5) || U < ch*(full?1:0.5)) return null;
  const cols = full? Math.floor(W/cw) : Math.ceil(W/cw);
  if(cols<1) return null;
  const ox = S.alignH==="left"?0 : S.alignH==="right"? W-cols*cw : (W-cols*cw)/2;
  const cells=[]; const eps=1e-6;
  for(let c=0;c<cols;c++){
    const off = stepOffset(wall,m,c), colX = ox + c*cw;
    const hOut = colX < -0.004 || colX+cw > W+0.004;
    // `anchor` = the boundary between the bottom offset gap (below) and the main
    // stack (above). Strip index i>=1 = the main stack going up; i<=0 = strips that
    // fall INTO the offset gap (only used in fill mode, as cuts). Full mode keeps the
    // gap empty (painted); fill mode fills it with cut strips.
    const anchor = b.bottom - off;
    const iHi = Math.floor(U/ch)+2;
    const iLo = full ? 1 : (-Math.floor(off/ch)-1);
    for(let i=iHi; i>=iLo; i--){
      const yTop = anchor - i*ch, yBot = yTop + ch;
      if(Math.min(yBot,b.bottom) - Math.max(yTop,b.top) <= eps) continue; // no band overlap
      const fullyInside = yTop >= b.top-0.004 && yBot <= b.bottom+0.004 && !hOut;
      if(full){ if(i<1) continue; if(!fullyInside) continue; }            // whole strips only, gap empty
      const cell={x:colX, y:yTop, w:cw, h:ch, c, r:i, off:false};
      const os = openingState(cell, wall);
      if(os==="inside") continue;
      if(full && os==="cut") continue;
      cell.cut = full ? false : (!fullyInside || i<1 || os==="cut");
      cells.push(cell);
    }
  }
  if(!cells.length) return null;
  return {cells, full, cols};
}

/* =============== INCA 0082 mosaic (kind:"area" preview — §2c) ===============
   Tile the covered band with 20×10 cm cells cycling the 18 mosaic designs.
   Count stays area-based (countAreaModel); this is preview only. */
/* Mosaic (INCA) cell grid — orientation-aware. Shared by the drawer and the drag
   hit-test. Design index per cell is deterministic ((r*cols+c) mod N) so it stays
   stable for drag-swaps (customers rearrange which design sits where). */
function cellsMosaic(wall, m){
  const b=band(wall);
  if(!m.tiles || !m.tiles.length) return null;
  const eo=effOrient(m);
  const cw=eo?eo.w:(m.w||0.1), ch=eo?eo.h:(m.h||0.2), rot90=eo?eo.rot90:false;
  const W=b.W, U=b.usable;
  if(W<=0 || U<=0) return null;
  const cols=Math.ceil(W/cw), rows=Math.ceil(U/ch);
  const cells=[];
  for(let r=0;r<rows;r++) for(let c=0;c<cols;c++){
    const x=c*cw, y=b.bottom-(r+1)*ch, cell={x,y,w:cw,h:ch,c,r,key:c+","+r};
    if(openingState(cell,wall)==="inside") continue;
    cells.push(cell);
  }
  return {cells, cols, rows, cw, ch, rot90};
}
function mosaicDesign(wall, m, cell, cols){
  const o=wall.mosaicArr[cell.key];
  return o!==undefined ? o : (cell.r*cols + cell.c) % m.tiles.length;
}
function drawAreaMosaic(wall, m, X, Y, sc, b){
  const g=cellsMosaic(wall, m); if(!g || !g.cells.length) return "";
  let s="";
  for(const cell of g.cells){
    const fx=X(cell.x), fy=Y(cell.y), fw=cell.w*sc, fh=cell.h*sc;
    const tk=m.tiles[mosaicDesign(wall,m,cell,g.cols)];
    let inner=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="var(--kwp-panel-face)"/>`;
    inner+=orientedTile(tk, fx, fy, fw, fh, g.rot90, 0);
    inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="var(--kwp-panel-edge)" stroke-width="0.4"/>`;
    s+=`<g data-swap="${cell.key}" style="cursor:grab; touch-action:none;">${inner}</g>`;
  }
  return s;
}

/* =============== Preview =============== */
let PV=null;
function svgEl(){ return ROOT.querySelector(".svgbox svg"); }
function pvCoords(evt){
  const svg=svgEl(); if(!svg||!PV) return null;
  const rect=svg.getBoundingClientRect();
  const vw=svg.viewBox.baseVal.width, vh=svg.viewBox.baseVal.height;
  return {x:((evt.clientX-rect.left)*(vw/rect.width)-PV.pad)/PV.sc,
          y:((evt.clientY-rect.top)*(vh/rect.height)-PV.pad)/PV.sc};
}
function renderPreview(){
  const m=S.model, wall=S.walls[S.active], box=ROOT.querySelector(".svgbox");
  const W=+wall.w||0, H=+wall.h||0;
  $("kwp_pv_dims").textContent = W&&H ? `Wall ${wallLetter(S.active)} · ${W.toFixed(2)} × ${H.toFixed(2)} m` : "";
  if(!W||!H){ box.innerHTML=`<div style="padding:60px 20px; text-align:center; color:var(--kwp-grey); font-size:13px;">Enter the wall dimensions to see your layout.</div>`; PV=null; return; }
  const b=band(wall);
  const pad=36, padR=48, maxW=580, maxH=400;
  const sc=Math.min((maxW-pad-padR)/W,(maxH-2*pad)/H);
  const vw=W*sc+pad+padR, vh=H*sc+2*pad;
  PV={sc,pad,W,H};
  const X=x=>pad+x*sc, Y=y=>pad+y*sc;
  let imgList = m.imgs||[];
  if(m.kind==="surfrip"){
    const partner=modelById(m.partner);
    imgList=[...(m.tiles||[]), ...(wall.sr.combine? (partner.tiles||[]):[])];
  }
  let s=`<svg viewBox="0 0 ${vw} ${vh}" xmlns="http://www.w3.org/2000/svg">`;
  s+=`<defs>
    ${imgDefs(imgList)}
    <pattern id="cuthatch" width="7" height="7" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="7" height="7" fill="none"/><rect width="1.6" height="7" fill="#ae9e98" opacity="0.45"/></pattern>
    <clipPath id="bandclip"><rect x="${X(0)}" y="${Y(b.top)}" width="${W*sc}" height="${b.usable*sc}"/></clipPath>
  </defs>`;
  s+=`<rect x="${X(0)}" y="${Y(0)}" width="${W*sc}" height="${H*sc}" fill="var(--kwp-wall-bg)" stroke="#a3a3a4" stroke-width="1.2"/>`;
  if(S.skirt>0) s+=`<rect x="${X(0)}" y="${Y(b.bottom)}" width="${W*sc}" height="${(H-b.bottom)*sc}" fill="#e2ded8" stroke="#d9d5cf" stroke-width="0.6"/>`;
  s+=`<g class="kwp-snapgrid" style="display:none" opacity="0.5">`;
  if(m.step){
    // 25 cm horizontal step guide (shown while dragging a strip) — N7
    for(let gy=0.25; gy<H; gy+=0.25) s+=`<line x1="${X(0)}" y1="${Y(Math.max(0,b.bottom-gy))}" x2="${X(W)}" y2="${Y(Math.max(0,b.bottom-gy))}" stroke="#c9a94f" stroke-width="0.8" stroke-dasharray="3 3"/>`;
  } else {
    for(let gx=0.1; gx<W; gx+=0.1) s+=`<line x1="${X(gx)}" y1="${Y(0)}" x2="${X(gx)}" y2="${Y(H)}" stroke="#c9c4bd" stroke-width="${(Math.round(gx*10)%5===0)?0.7:0.3}"/>`;
    for(let gy=0.1; gy<H; gy+=0.1) s+=`<line x1="${X(0)}" y1="${Y(gy)}" x2="${X(W)}" y2="${Y(gy)}" stroke="#c9c4bd" stroke-width="${(Math.round(gy*10)%5===0)?0.7:0.3}"/>`;
  }
  s+=`</g>`;

  s+=`<g clip-path="url(#bandclip)">`;
  if(m.kind==="grid") s+=drawGridCells(m.step?cellsStep(wall,m):cellsGrid(wall,m), m, X, Y, sc, wall);
  else if(m.kind==="cosmic") s+=drawCosmic(wall, m, X, Y, sc);
  else if(m.kind==="trinity") s+=drawTrinity(wall, m, X, Y, sc);
  else if(m.kind==="hex") s+=drawHex(wall, m, X, Y, sc, b);
  else if(m.kind==="surfrip") s+=drawSurfRip(wall, m, X, Y, sc);
  else if(m.kind==="area"){
    s+=drawAreaMosaic(wall, m, X, Y, sc, b) ||
       `<text x="${X(W/2)}" y="${Y(b.top)+b.usable*sc/2}" text-anchor="middle" font-size="11" fill="#735f5f">Mosaic set — counted by covered area; layout drawing follows with your quote.</text>`;
  }
  s+=`</g>`;

  wall.open.forEach((o,i)=>{
    s+=`<g data-open="${i}" style="cursor:move; touch-action:none;">
      <rect x="${X(o.x)}" y="${Y(o.y)}" width="${o.w*sc}" height="${o.h*sc}" fill="#fafafa" stroke="#737373" stroke-dasharray="5 3" stroke-width="1.1"/>
      <text x="${X(o.x)+o.w*sc/2}" y="${Y(o.y)+o.h*sc/2}" text-anchor="middle" dominant-baseline="middle" font-size="10" fill="#737373">opening ${i+1} · drag me</text></g>`;
  });

  s+=`<line x1="${X(0)}" y1="${vh-14}" x2="${X(W)}" y2="${vh-14}" stroke="#a3a3a4" stroke-width="0.8"/>`;
  s+=`<text x="${X(W/2)}" y="${vh-4}" text-anchor="middle" font-size="11" fill="#735f5f">${W.toFixed(2)} m</text>`;
  s+=`<line x1="${vw-20}" y1="${Y(0)}" x2="${vw-20}" y2="${Y(H)}" stroke="#a3a3a4" stroke-width="0.8"/>`;
  s+=`<text x="${vw-8}" y="${Y(H/2)}" text-anchor="middle" font-size="11" fill="#735f5f" transform="rotate(90 ${vw-8} ${Y(H/2)})">${H.toFixed(2)} m</text>`;
  s+=`</svg>`;
  box.innerHTML=s;
  bindDrag();
}

function drawGridCells(r, m, X, Y, sc, wall){
  if(!r) return "";
  let s="";
  for(const c of r.cells){
    const fx=X(c.x), fy=Y(c.y), fw=c.w*sc, fh=c.h*sc, key=c.c+","+c.r;
    if(c.off){
      // Leave-empty placeholder — tap the "+" (a data-kwp-off target) to fill it back.
      s+=`<g data-kwp-off="${key}" style="cursor:pointer;"><rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="transparent" stroke="#b9b2a6" stroke-width="0.9" stroke-dasharray="3 3"/><text x="${fx+fw/2}" y="${fy+fh/2}" text-anchor="middle" dominant-baseline="middle" font-size="13" fill="#a3a3a4">+</text></g>`;
      continue;
    }
    // Tile key: FUTUR A/B, 2-piece set (N4), or single tile (N1).
    let tk=null;
    if(m.tileAB){ const d = wall.futArr[key]!==undefined ? wall.futArr[key] : (c.c+c.r)%2; tk=m.tileAB[d]; }
    else if(m.setCols){ const pi = wall.setArr[key]!==undefined ? wall.setArr[key] : (c.c % m.setCols); tk=m.tiles[pi]; }
    else if(m.tile){ tk=m.tile; }
    const rot = wall.rot[key]||0;                                   // N3 manual flip/rotation
    const eo = effOrient(m);                                        // orientation (AQUA/CURVE/ORIGAMI)
    const rotAttr = rot ? ` transform="rotate(${rot*90} ${fx+fw/2} ${fy+fh/2})"` : "";
    let inner="";
    // N5: transparent models (0039 BUMBLE) drop the opaque backing rect + non-cut
    // border so the PNG alpha reveals the wall colour underneath.
    if(!m.transparent) inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="var(--kwp-panel-face)" stroke="var(--kwp-panel-edge)" stroke-width="0.9"/>`;
    if(tk) inner += eo ? orientedTile(tk, fx, fy, fw, fh, eo.rot90, rot)
                       : `<g${rotAttr}>`+tileUse(tk, fx, fy, fw, fh)+`</g>`;
    if(c.led && m.id==="slate") inner+=`<path d="M ${fx+2} ${fy+fh-2.5} h ${fw-4}" stroke="#ffd230" stroke-width="2.2" opacity="0.85"/><path d="M ${fx+2} ${fy+fh-2.5} h ${fw-4}" stroke="#ffd230" stroke-width="6" opacity="0.15"/>`;
    if(c.cut){
      inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="url(#cuthatch)"/>`;
      inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="#ae9e98" stroke-width="1" stroke-dasharray="4 3"/>`;
    } else if(!m.transparent){
      inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="var(--kwp-panel-edge)" stroke-width="0.9"/>`;
    }
    // Leave-empty "×" corner target (models that support it: SLATE). Rendered above
    // the tile; caught in pointerdown before the swap/tap branch (N3 collision fix).
    if(m.offable){ const bx=fx+fw-13, by=fy+3;
      inner+=`<g data-kwp-off="${key}" style="cursor:pointer;"><rect x="${bx}" y="${by}" width="10" height="10" fill="#ffffff" fill-opacity="0.82" stroke="#b9b2a6" stroke-width="0.6"/><text x="${bx+5}" y="${by+5.4}" text-anchor="middle" dominant-baseline="central" font-size="8.5" fill="#735f5f">×</text></g>`;
    }
    s += `<g data-swap="${key}" style="cursor:grab; touch-action:none;">${inner}</g>`;
  }
  return s;
}

function drawCosmic(wall, m, X, Y, sc){
  const p=packCosmic(wall,m); if(!p) return "";
  const {g}=p; let s="";
  if(wall.cosmic.fillEdges){
    const b=g.b;
    const strips=[
      {x:0,y:b.top,w:g.ox,h:b.usable},
      {x:g.ox+g.cols*g.cs,y:b.top,w:b.W-(g.ox+g.cols*g.cs),h:b.usable},
      {x:g.ox,y:b.top,w:g.cols*g.cs,h:g.oy-b.top},
      {x:g.ox,y:g.oy+g.rows*g.cs,w:g.cols*g.cs,h:b.bottom-(g.oy+g.rows*g.cs)}
    ];
    strips.forEach(st=>{ if(st.w>0.005&&st.h>0.005)
      s+=`<rect x="${X(st.x)}" y="${Y(st.y)}" width="${st.w*sc}" height="${st.h*sc}" fill="url(#cuthatch)" stroke="#ae9e98" stroke-width="0.7" stroke-dasharray="4 3"/>`; });
  }
  for(let r=0;r<g.rows;r++) for(let c=0;c<g.cols;c++){
    if(g.grid[r][c]==="blocked") continue;
    s+=`<rect x="${X(g.ox+c*g.cs)}" y="${Y(g.oy+r*g.cs)}" width="${g.cs*sc}" height="${g.cs*sc}" fill="none" stroke="#ddd8d1" stroke-width="0.5" stroke-dasharray="2 3"/>`;
  }
  p.placed.forEach((t,i)=>{
    const sku=m.skus.find(k=>k.id===t.sku);
    const fx=X(g.ox+t.c*g.cs), fy=Y(g.oy+t.r*g.cs), f=t.s*g.cs*sc;
    s+=`<g data-tile="${i}" style="cursor:move; touch-action:none;">`;
    s+=`<rect x="${fx}" y="${fy}" width="${f}" height="${f}" fill="var(--kwp-panel-face)"/>`;
    s+=tileUse(sku.tile, fx, fy, f, f);
    s+=`<rect x="${fx}" y="${fy}" width="${f}" height="${f}" fill="none" stroke="var(--kwp-panel-edge)" stroke-width="1"/>`;
    s+=`</g>`;
  });
  return s;
}

function drawTrinity(wall, m, X, Y, sc){
  const r=cellsTrinity(wall,m); if(!r) return "";
  let s="";
  for(const c of r.cells){
    const fx=X(c.x), fy=Y(c.y), fw=c.w*sc, fh=c.h*sc, key=c.c+","+c.r;
    const rot=wall.rot[key]||0;                                     // N3 rotation
    const rotAttr = rot ? ` transform="rotate(${rot*90} ${fx+fw/2} ${fy+fh/2})"` : "";
    let inner=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="var(--kwp-panel-face)"/>`;
    inner+=`<g${rotAttr}>`+tileUse(c.def.tile, fx, fy, fw, fh)+`</g>`;
    if(c.cut){
      inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="url(#cuthatch)"/>`;
      inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="#ae9e98" stroke-width="1" stroke-dasharray="4 3"/>`;
    } else {
      inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="var(--kwp-panel-edge)" stroke-width="0.9"/>`;
    }
    s+=`<g data-swap="${key}" style="cursor:grab; touch-action:none;">${inner}</g>`;
  }
  return s;
}

function drawSurfRip(wall, m, X, Y, sc){
  const r=cellsSurfRip(wall,m); if(!r) return "";
  let s="";
  for(const c of r.cells){
    const fx=X(c.x), fy=Y(c.y), fw=c.w*sc, fh=c.h*sc;
    let inner="";
    if(!c.assign){
      inner=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="#b9b2a6" stroke-width="0.9" stroke-dasharray="3 3"/>`;
    } else {
      const mo=modelById(c.assign.mo);
      const tileKey=mo.tiles[c.assign.i];
      inner=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="var(--kwp-panel-face)"/>`;
      const rot=c.rot? ` transform="rotate(${c.rot*90} ${fx+fw/2} ${fy+fh/2})"`:"";
      inner+=`<g${rot}>`+tileUse(tileKey, fx, fy, fw, fh)+`</g>`;
      if(c.cut){
        inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="url(#cuthatch)"/>`;
        inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="#ae9e98" stroke-width="1" stroke-dasharray="4 3"/>`;
      } else {
        inner+=`<rect x="${fx}" y="${fy}" width="${fw}" height="${fh}" fill="none" stroke="var(--kwp-panel-edge)" stroke-width="0.9"/>`;
      }
    }
    s+=`<g data-swap="${c.c},${c.r}" style="cursor:grab; touch-action:none;">${inner}</g>`;
  }
  return s;
}

function drawHex(wall, m, X, Y, sc, b){
  const res=hexCells(wall,m); if(!res) return "";
  let s="", cid=0;
  for(const cell of res.cells){
    const cx=X(cell.cx), cy=Y(cell.cy), rw=cell.w*sc/2, rh=cell.h*sc/2;
    const pts=[...Array(6)].map((_,i)=>{const a=Math.PI/3*i;return `${(cx+rw*Math.cos(a)).toFixed(1)},${(cy+rh*Math.sin(a)).toFixed(1)}`}).join(" ");
    if(cell.off){
      const inner=`<polygon points="${pts}" fill="none" stroke="#b9b2a6" stroke-width="0.9" stroke-dasharray="3 3"/><text x="${cx}" y="${cy}" text-anchor="middle" dominant-baseline="middle" font-size="13" fill="#a3a3a4">+</text>`;
      s+=`<g data-kwp-off="${cell.key}" style="cursor:pointer;">${inner}</g>`;
      continue;
    }
    const rot=wall.rot[cell.key]||0;                                // N3 rotation
    const rotAttr = rot ? ` transform="rotate(${rot*90} ${cx} ${cy})"` : "";
    const hid="kwphx"+(cid++);
    let inner=`<clipPath id="${hid}"><polygon points="${pts}"/></clipPath>`;
    // Rotate the photo INSIDE the fixed hexagon clip (shape stays put, image turns).
    inner+=`<g clip-path="url(#${hid})"><g${rotAttr}>`+tileUse(cell.led?"hexA":"hexB", cx-rw, cy-rh, rw*2, rh*2)+`</g></g>`;
    inner+=`<polygon points="${pts}" fill="none" stroke="var(--kwp-panel-edge)" stroke-width="0.8"/>`;
    if(cell.led){
      inner+=`<polygon points="${pts}" fill="none" stroke="#ffd230" stroke-width="1.8" opacity="0.75"/>`;
      inner+=`<polygon points="${pts}" fill="none" stroke="#ffd230" stroke-width="5" opacity="0.15"/>`;
    }
    if(cell.cut) inner+=`<polygon points="${pts}" fill="url(#cuthatch)" stroke="#ae9e98" stroke-width="0.9" stroke-dasharray="4 3"/>`;
    // Leave-empty "×" corner target (HEXAGON supports it).
    const bx=cx+rw-11, by=cy-rh+1;
    inner+=`<g data-kwp-off="${cell.key}" style="cursor:pointer;"><rect x="${bx}" y="${by}" width="9" height="9" fill="#ffffff" fill-opacity="0.82" stroke="#b9b2a6" stroke-width="0.6"/><text x="${bx+4.5}" y="${by+5}" text-anchor="middle" dominant-baseline="central" font-size="7.5" fill="#735f5f">×</text></g>`;
    s+=`<g data-swap="${cell.key}" style="cursor:grab; touch-action:none;">${inner}</g>`;
  }
  return s;
}

/* =============== Drag interactions =============== */
let drag=null;
function bindDrag(){
  const svg=svgEl(); if(!svg) return;
  svg.addEventListener("pointerdown", e=>{
    // N3: the "×"/"+" leave-empty target must be caught BEFORE the data-swap branch,
    // otherwise any pointer inside the cell becomes a swap/tap and would rotate.
    const off=e.target.closest("[data-kwp-off]");
    if(off){
      e.preventDefault();
      const w=S.walls[S.active], m=S.model, key=off.getAttribute("data-kwp-off");
      const offMap = m.kind==="hex" ? w.hexOff : w.slateOff;
      offMap[key] = !offMap[key];
      renderAll();
      return;
    }
    const og=e.target.closest("[data-open]"); const tg=e.target.closest("[data-tile]"); const sg=e.target.closest("[data-swap]");
    if(!og && !tg && !sg) return;
    e.preventDefault();
    try{ svg.setPointerCapture(e.pointerId); }catch(err){}
    const p=pvCoords(e);
    if(og) drag={type:"open", i:+og.dataset.open, g:og, start:p};
    else if(tg) drag={type:"tile", i:+tg.dataset.tile, g:tg, start:p};
    else drag={type:"swap", key:sg.dataset.swap, g:sg, start:p};
    const w=S.walls[S.active];
    if(og) drag.orig={...w.open[drag.i]};
    if(tg) drag.orig={...w.cosmic.placed.list[drag.i]};
    const sn=svg.querySelector(".kwp-snapgrid"); if(sn) sn.style.display="block";
  });
  svg.addEventListener("pointermove", e=>{
    if(!drag) return;
    const p=pvCoords(e); if(!p) return;
    drag.g.setAttribute("transform",`translate(${(p.x-drag.start.x)*PV.sc},${(p.y-drag.start.y)*PV.sc})`);
    drag.last=p;
  });
  svg.addEventListener("pointerup", ()=>{
    if(!drag) return;
    const w=S.walls[S.active], m=S.model, p=drag.last;
    const moved = p && (Math.abs(p.x-drag.start.x)+Math.abs(p.y-drag.start.y) > 0.05);
    if(drag.type==="open" && p){
      const dxm=p.x-drag.start.x, dym=p.y-drag.start.y;
      const o=w.open[drag.i];
      o.x=Math.round(Math.min(Math.max(0,drag.orig.x+dxm),Math.max(0,(+w.w)-o.w))*20)/20;
      o.y=Math.round(Math.min(Math.max(0,drag.orig.y+dym),Math.max(0,(+w.h)-o.h))*20)/20;
      w.cosmic.placed=null;
    } else if(drag.type==="tile" && p){
      const dxm=p.x-drag.start.x, dym=p.y-drag.start.y;
      const g=cellsCosmic(w,m);
      const t=w.cosmic.placed.list[drag.i];
      const nc=Math.round(drag.orig.c+dxm/g.cs), nr=Math.round(drag.orig.r+dym/g.cs);
      if(canPlace(w,m,drag.i,nc,nr,t.s)){ t.c=nc; t.r=nr; }
    } else if(drag.type==="swap"){
      const key=drag.key;
      if(m.step){
        // STEP (AQUA/CURVE): tap = flip 180°; vertical drag = snap column offset;
        // horizontal drag = swap the two columns' offsets (N7).
        if(!moved){ w.rot[key]=((w.rot[key]||0)+2)%4; }
        else if(p){
          const dxm=p.x-drag.start.x, dym=p.y-drag.start.y, c1=+key.split(",")[0];
          if(Math.abs(dxm) > Math.abs(dym)){
            const layout=cellsStep(w,m);
            const tgt = layout && layout.cells.find(c=> p.x>=c.x && p.x<=c.x+c.w && p.y>=c.y && p.y<=c.y+c.h);
            if(tgt && tgt.c!==c1){ const o1=stepOffset(w,m,c1), o2=stepOffset(w,m,tgt.c); w.stepOff[c1]=o2; w.stepOff[tgt.c]=o1; }
          } else {
            let no = stepOffset(w,m,c1) - dym;          // drag up (dym<0) raises the column
            w.stepOff[c1] = Math.max(0, Math.min(0.75, Math.round(no/0.25)*0.25));
          }
        }
      } else if(m.kind==="surfrip"){
        if(!moved){ w.sr.rot[key] = ((w.sr.rot[key]||0)+1)%4; }
        else if(p){
          const layout=cellsSurfRip(w,m);
          if(layout){
            const cells=layout.cells;
            const tgt=cells.find(c=> p.x>=c.x && p.x<=c.x+c.w && p.y>=c.y && p.y<=c.y+c.h);
            const c1=cells.find(c=> (c.c+","+c.r)===key);
            if(tgt && c1){ const k2=tgt.c+","+tgt.r; if(key!==k2){ const v1=c1.assign||null, v2=tgt.assign||null; w.sr.arr[key]=v2; w.sr.arr[k2]=v1; } }
          }
        }
      } else if(m.kind==="area"){
        // INCA mosaic: drag one piece onto another to swap which design sits where.
        if(moved && p){
          const layout=cellsMosaic(w,m);
          if(layout){
            const tgt=layout.cells.find(c=> p.x>=c.x && p.x<=c.x+c.w && p.y>=c.y && p.y<=c.y+c.h);
            const c1=layout.cells.find(c=> c.key===key);
            if(tgt && c1 && tgt.key!==key){
              const d1=mosaicDesign(w,m,c1,layout.cols), d2=mosaicDesign(w,m,tgt,layout.cols);
              w.mosaicArr[key]=d2; w.mosaicArr[tgt.key]=d1;
            }
          }
        }
      } else {
        // grid / set / trinity / hex: tap = rotate; drag onto another = swap.
        if(!moved){
          const steps=(effW(m)===effH(m))?4:2;         // squares 0/90/180/270, rectangles 0/180
          w.rot[key]=((w.rot[key]||0)+4/steps)%4;
        } else if(p){
          const layout = m.kind==="trinity" ? cellsTrinity(w,m)
                       : m.kind==="hex" ? hexCells(w,m)
                       : cellsGrid(w,m);
          if(layout){
            const cells=layout.cells;
            const tgt = m.kind==="hex"
              ? cells.find(c=> Math.abs(p.x-c.cx)<=c.w/2 && Math.abs(p.y-c.cy)<=c.h/2)
              : cells.find(c=> p.x>=c.x && p.x<=c.x+c.w && p.y>=c.y && p.y<=c.y+c.h);
            const c1 = cells.find(c=> (c.key||c.c+","+c.r)===key);
            if(tgt && c1 && !tgt.off && !c1.off){
              const k2 = tgt.key || tgt.c+","+tgt.r;
              if(key!==k2){
                // Rotation travels with the panel.
                const r1=w.rot[key]||0, r2=w.rot[k2]||0; w.rot[key]=r2; w.rot[k2]=r1;
                if(m.kind==="trinity"){ const v1=c1.idx, v2=tgt.idx; w.triArr[key]=v2; w.triArr[k2]=v1; }
                else if(m.setCols){ const val=c=>{ const k=c.c+","+c.r; return w.setArr[k]!==undefined? w.setArr[k] : (c.c%m.setCols); }; const v1=val(c1), v2=val(tgt); w.setArr[key]=v2; w.setArr[k2]=v1; }
                else if(m.id==="futur"){ const val=c=>{ const k=c.c+","+c.r; return w.futArr[k]!==undefined? w.futArr[k] : (c.c+c.r)%2; }; const v1=val(c1), v2=val(tgt); w.futArr[key]=v2; w.futArr[k2]=v1; }
                else if(m.id==="slate"){ const v1=!!c1.led, v2=!!tgt.led; w.slateArr[key]=v2; w.slateArr[k2]=v1; }
                else if(m.kind==="hex"){ const v1=!!c1.led, v2=!!tgt.led; w.hexArr[key]=v2; w.hexArr[k2]=v1; }
              }
            }
          }
        }
      }
    }
    drag=null; renderAll();
  });
}
function canPlace(w,m,self,c,r,sz){
  const g=cellsCosmic(w,m); if(!g) return false;
  if(c<0||r<0||c+sz>g.cols||r+sz>g.rows) return false;
  for(let dr=0;dr<sz;dr++) for(let dc=0;dc<sz;dc++){ if(g.grid[r+dr][c+dc]!=="free") return false; }
  const list=w.cosmic.placed.list;
  for(let i=0;i<list.length;i++){
    if(i===self) continue; const t=list[i];
    if(c < t.c+t.s && t.c < c+sz && r < t.r+t.s && t.r < r+sz) return false;
  }
  return true;
}

/* =============== Model combobox =============== */
function comboLabel(m){ return m.name; }
function renderComboList(query){
  const list=$("kwp_modelList");
  const q=(query||"").trim().toLowerCase();
  const matches = MODELS.filter(m => !q || m.name.toLowerCase().includes(q) || (m.sku||"").toLowerCase().includes(q));
  list.innerHTML = matches.length
    ? matches.map(m=>`<div class="kwp-combo__opt" data-model="${m.id}"><span>${m.name.split(" — ")[0]}</span><span class="sku">${m.sku||""}</span></div>`).join("")
    : `<div class="kwp-combo__empty">No model matches "${query}" — try the name (e.g. WAVES) or SKU (e.g. 0058).</div>`;
  list.hidden=false;
}
function selectModel(id){
  const m=modelById(id); if(!m) return;
  S.model=m;
  S.fillMode = m.defaultFill || "fill";
  S.orient = orientCfg(m) ? orientCfg(m).def : null;
  S.accProfiles=0; S.accProjectors=0; S.triExtra=0;
  S.walls.forEach(w=>{ w.cosmic.placed=null; clearCellMaps(w); w.sr={combine:false, mainSets:null, partnerSets:null, arr:{}, rot:{}}; });
  $("kwp_modelSearch").value=comboLabel(m);
  $("kwp_modelList").hidden=true;
  renderAll();
}
function bindCombo(){
  const input=$("kwp_modelSearch"), list=$("kwp_modelList");
  input.addEventListener("focus", ()=>{ input.select(); renderComboList(""); });
  input.addEventListener("input", ()=>renderComboList(input.value));
  input.addEventListener("keydown", e=>{
    if(e.key==="Enter"){
      e.preventDefault();
      const first=list.querySelector("[data-model]");
      if(first) selectModel(first.dataset.model);
    }
    if(e.key==="Escape"){ list.hidden=true; input.value=comboLabel(S.model); }
  });
  list.addEventListener("pointerdown", e=>{
    const opt=e.target.closest("[data-model]");
    if(opt){ e.preventDefault(); selectModel(opt.dataset.model); }
  });
  document.addEventListener("click", e=>{
    if(!e.target.closest("#KandesWallPlanner .kwp-combo")){ list.hidden=true; if(!input.value) input.value=comboLabel(S.model); }
  });
  input.value=comboLabel(S.model);
}

/* =============== Model meta / notices =============== */
function renderModelMeta(){
  const m=S.model, bEl=$("kwp_modelbadges"), n=$("kwp_modelnotices");
  let bs="";
  if(m.w && m.h && m.kind!=="cosmic" && m.kind!=="hex") bs+=`<span class="badge">${Math.round(effW(m)*100)} × ${Math.round(effH(m)*100)} cm</span>`;
  if(m.kind==="area") bs+=`<span class="badge">mosaic set · by area</span>`;
  if(m.kind==="cosmic") bs+=`<span class="badge">60×60 &amp; 30×30 cm mix</span>`;
  if(m.kind==="hex") bs+=`<span class="badge">hexagonal</span>`;
  if(m.setCols) bs+=`<span class="badge">set of ${m.setCols} designs</span>`;
  if(m.step) bs+=`<span class="badge">quarter-panel step</span>`;
  if(m.pkg>1) bs+=`<span class="badge">${m.set2?"sets":"packs"} of ${m.pkg}</span>`;
  if(m.kind==="trinity") bs+=`<span class="badge">sets of 3 + LED triangle</span>`;
  if(m.kind==="surfrip") bs+=`<span class="badge">set of ${m.setSize} designs</span><span class="badge note">combines with ${modelById(m.partner).name.split(" ")[0]}</span>`;
  if(m.led==="integrated") bs+=`<span class="badge led">integrated LED</span>`;
  if(m.led==="optional") bs+=`<span class="badge led">LED-ready</span>`;
  if(m.led==="customer") bs+=`<span class="badge led">LED-ready · customer-supplied</span>`;
  if(m.kind==="cosmic") bs+=`<span class="badge led">LED / non-LED mix</span>`;
  if(m.aluAll||m.id==="slate"||m.kind==="hex") bs+=`<span class="badge note">aluminium profile</span>`;
  bEl.innerHTML=bs;

  let html="";
  if(m.aluAll){
    html+=`<div class="notice"><b>FUTUR carries an aluminium LED profile in every panel.</b> Cutting is possible but tricky and affects the light line — if you choose "Fill the wall" in step 3, every cut panel is flagged in the layout plan for your installer. Drag one panel onto another in the preview to swap the two designs.</div>`;
  }
  if(m.set2 && m.kind==="grid") html+=`<div class="notice">${m.name.split(" ")[0]} comes as a <b>set of two — one panel with the LED profile, one without</b>. Cuts land on the non-LED panel by default; <b>drag panels in the preview</b> to move the LED positions, or <b>click a panel</b> to leave that spot empty.</div>`;
  if(m.kind==="hex") html+=`<div class="notice">HEXAGON comes as a <b>set of two — one with the LED profile, one without</b>. <b>Drag hexagons</b> to move the LED positions, or <b>click one</b> to leave that spot empty. Trimming lands on non-LED panels by default.</div>`;
  if(m.kind==="cosmic") html+=`<div class="notice"><b>COSMIC is modular</b> — combine large and medium, LED and non-LED. Set your mix in step 3, then <b>drag panels in the preview</b> to arrange them.</div>`;
  if(m.kind==="trinity") html+=`<div class="notice"><b>TRINITY comes in sets of 3 squares</b> (0121 + 0221 + 0321) <b>+ 1 triangle LED element</b>. <b>Drag squares in the preview</b> to rearrange them. Triangle elements are positioned during installation; you can order additional triangle elements in step 3 — priced on request.</div>`;
  if(m.kind==="surfrip"){
    const partner=modelById(m.partner);
    html+=`<div class="notice"><b>${m.name.split(" ")[0]} comes as a set of ${m.setSize} different flowing designs.</b> <b>Drag panels</b> to rearrange, <b>tap one to rotate it 90°</b>, and combine with ${partner.name.split(" ")[0]} for one continuous installation (step 3).</div>`;
  }
  // N4: 2-piece sets (MARIS / SOOTHE / SATIN / MYSTIC)
  if(m.setCols) html+=`<div class="notice"><b>${m.name.split(" ")[0]} comes as a set of two designs</b> that alternate left and right across each row. <b>Drag one panel onto another</b> to rearrange them, and <b>tap a panel</b> to rotate it.</div>`;
  // N7: AQUA / CURVE quarter-panel step grid + customer-supplied LED disclaimer (no contractions)
  if(m.step) html+=`<div class="notice"><b>${m.name.split(" ")[0]} is a 100 × 20 cm strip.</b> By default the strips stand vertically and step up the wall in quarter-panel (25 cm) increments for a rising diagonal — choose a horizontal layout in step 3 if you prefer. <b>Drag a strip up or down</b> to change its step (it snaps every 25 cm), <b>drag one strip onto another</b> to reorder, and <b>tap a strip</b> to flip it.<br><span style="display:block; margin-top:6px;">LED is optional on this panel — it has a recess on the back for an LED strip you fit yourself. Kandes does not supply the strip for this model, so you are free to choose any strip and light colour.</span></div>`;
  // INCA mosaic — orientation + drag note
  if(m.kind==="area") html+=`<div class="notice"><b>${m.name.split(" ")[0]} is a mosaic of 20 × 10 cm pieces.</b> The pieces stand vertically by default — choose a horizontal layout in step 3 if you prefer. <b>Drag one piece onto another</b> in the preview to rearrange the designs. The count is worked out from the area you cover.</div>`;
  n.innerHTML=html;
}

/* =============== Step 3: coverage + mix =============== */
function renderFill(){
  const m=S.model, box=$("kwp_fillbox"), w=S.walls[S.active];
  let html="";
  const seg=(v1,l1,s1,v2,l2,s2,cur)=>`<div class="seglabel" style="margin-top:0;">Coverage</div>
    <div class="seg" data-kwp-fillseg>
      <button type="button" data-v="${v1}" class="${cur===v1?"on":""}">${l1}<br><span style="font-size:11px; opacity:.75;">${s1}</span></button>
      <button type="button" data-v="${v2}" class="${cur===v2?"on":""}">${l2}<br><span style="font-size:11px; opacity:.75;">${s2}</span></button>
    </div>`;
  // Panel orientation (AQUA/CURVE/INCA/ORIGAMI) — vertical or horizontal placement.
  if(orientCfg(m)){
    const cur=S.orient||orientCfg(m).def;
    html+=`<div class="seglabel" style="margin-top:0;">Panel orientation</div>
      <div class="seg" data-kwp-orientseg>
        <button type="button" data-o="v" class="${cur==="v"?"on":""}">Vertical</button>
        <button type="button" data-o="h" class="${cur==="h"?"on":""}">Horizontal</button>
      </div>`;
  }
  if(m.kind==="grid"||m.kind==="trinity"||m.kind==="surfrip"){
    html+=seg("fill","Fill the wall","edge panels cut to size","full","Full panels only","no cutting — edges stay painted",S.fillMode);
  } else if(m.kind==="hex"){
    html+=seg("fill","Fill the wall","edge hexagons trimmed","full","Full hexagons only","no cutting — edges stay painted",S.fillMode);
  } else if(m.kind==="cosmic"){
    html+=seg("fill","Fill the wall","edge strips get cut panels","full","Composition only","edges stay painted",w.cosmic.fillEdges?"fill":"full");
    if(w.cosmic.fillEdges){
      html+=`<div style="margin:8px 0 4px;">
        <label>Cut panels from (non-LED advised)</label>
        <select id="kwp_fillSku"><option value="0412" ${w.cosmic.fillSku==="0412"?"selected":""}>COSMIC 0412 · Medium 30×30</option><option value="0312" ${w.cosmic.fillSku==="0312"?"selected":""}>COSMIC 0312 · Large 60×60</option></select>
      </div>`;
    }
  }
  box.innerHTML=html;
  const os=box.querySelector("[data-kwp-orientseg]");
  if(os) os.querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>{
    S.orient=b.dataset.o;
    S.walls.forEach(x=>{ x.cosmic.placed=null; clearCellMaps(x); });  // dims re-index
    renderAll();
  }));
  const fs=box.querySelector("[data-kwp-fillseg]");
  if(fs) fs.querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>{
    if(m.kind==="cosmic"){ w.cosmic.fillEdges = b.dataset.v==="fill"; }
    else S.fillMode=b.dataset.v;
    renderAll();
  }));
  const fk=$("kwp_fillSku");
  if(fk) fk.addEventListener("change",e=>{ w.cosmic.fillSku=e.target.value; renderAll(); });
  $("kwp_alignbox").style.display = ((m.kind==="grid"&&!m.step)||m.kind==="cosmic"||m.kind==="trinity"||m.kind==="surfrip") ? "" : "none";
}

function stepper(key,val){
  return `<div class="stepper"><button type="button" data-step="-1" data-key="${key}" aria-label="decrease">−</button><span>${val||0}</span><button type="button" data-step="1" data-key="${key}" aria-label="increase">+</button></div>`;
}
function renderMix(){
  const m=S.model, box=$("kwp_mixbox"), w=S.walls[S.active];
  let html="";
  if(m.kind==="cosmic"){
    const g=cellsCosmic(w,m);
    const counts=w.cosmic.counts;
    const used = 4*(counts["0012"]+counts["0312"]) + (counts["0212"]+counts["0412"]);
    m.skus.forEach(k=>{
      html+=`<div class="accrow"><div class="desc">COSMIC ${k.id} — ${k.label}${k.led?` <span class="badge led" style="margin-left:4px;">LED</span>`:""}</div>${stepper("cosmic:"+k.id, counts[k.id])}</div>`;
    });
    if(g){
      const p=packCosmic(w,m);
      let cl="", warn=false;
      if(used<g.free) cl=`Your wall block holds ${g.free} tiles of 30 cm — ${g.free-used} still unassigned (they stay painted unless you add panels).`;
      else if(used===g.free) cl=`Perfect fit: all ${g.free} tiles assigned.`;
      else {cl=`${used-g.free} tile(s) more than the block holds — remove some panels.`; warn=true;}
      if(p&&p.misfit){ cl+=` ${p.misfit} large panel(s) don't fit the remaining space.`; warn=true; }
      if(w.cosmic.fillEdges){ const fc=cosmicFillCount(w,m); cl+=` Edge strips ≈ ${g.stripArea.toFixed(2)} m² → ${fc} cut ${w.cosmic.fillSku==="0312"?"large":"medium"} panels.`; }
      html+=`<div class="capline${warn?" warn":""}">${cl}</div>`;
    }
    html+=`<p class="hint">Tip: drag panels in the preview to arrange your composition.</p>`;
  }
  if(m.kind==="trinity"){
    const r=cellsTrinity(w,m);
    if(r) html+=`<div class="capline">${r.total} squares on this wall → ${Math.ceil(r.total/3)} sets. Each set: one 0121 + one 0221 + one 0321 + one triangle LED element.</div>`;
    // Extra triangle LED elements — orderable on request (one is included per set).
    html+=`<div class="accrow"><div class="desc">Additional LED triangle elements <small>One is included per set; order more if you like — priced on request.</small></div>${stepper("triExtra", S.triExtra)}</div>`;
    html+=`<p class="hint">Tip: drag one square onto another to swap them · tap a square to rotate it.</p>`;
  }
  if(m.id==="futur"){
    html+=`<p class="hint">FUTUR pairs two mirrored designs — drag one panel onto another to swap them · tap a panel to rotate it.</p>`;
  }
  if(m.id==="slate"||m.kind==="hex"){
    html+=`<p class="hint">Tap a panel to rotate it · drag one onto another to move the LED position · use the × to leave a spot empty (tap the + to fill it back).</p>`;
  }
  if(m.step){
    const r=cellsStep(w,m);
    if(r) html+=`<div class="capline">${r.cells.length} strips on this wall.</div>`;
    html+=`<p class="hint">Drag a strip up or down to step it — snaps every 25 cm. Drag one strip onto another to reorder · tap a strip to flip it.</p>`;
  } else if(m.setCols){
    html+=`<p class="hint">Left and right designs alternate across each row. Drag one panel onto another to rearrange · tap a panel to rotate it.</p>`;
  } else if(m.kind==="grid" && !m.set2 && m.id!=="futur"){
    html+=`<p class="hint">Tap a panel to rotate it · drag one panel onto another to rearrange.</p>`;
  }
  if(m.kind==="surfrip"){
    const partner=modelById(m.partner), st=w.sr;
    const r=cellsSurfRip(w,m);
    html+=`<label class="check" style="margin-bottom:6px;"><input type="checkbox" id="kwp_srCombine" ${st.combine?"checked":""}>
      <span>Combine with ${partner.name.split(" — ")[0]}<span class="hint" style="display:block; margin-top:2px;">${m.name.split(" ")[0]} and ${partner.name.split(" ")[0]} are designed to flow into each other in one installation.</span></span></label>`;
    if(st.combine && r){
      html+=`<div class="accrow"><div class="desc">${m.name.split(" ")[0]} sets <small>${m.setSize} panels per set</small></div>${stepper("sr:main", st.mainSets)}</div>`;
      html+=`<div class="accrow"><div class="desc">${partner.name.split(" ")[0]} sets <small>${partner.setSize} panels per set</small></div>${stepper("sr:part", st.partnerSets)}</div>`;
      const spots=r.cells.length, pool=r.poolSize;
      let cl=`Your wall holds ${spots} panels — your sets give ${pool}.`;
      if(pool<spots) cl+=` ${spots-pool} spots stay painted.`;
      if(pool>spots) cl+=` ${pool-spots} panels don't fit this wall.`;
      html+=`<div class="capline${pool>spots?" warn":""}">${cl}</div>`;
    }
    html+=`<p class="hint">Drag a panel onto another to swap them · click a panel to rotate it 90°.</p>`;
  }
  box.innerHTML=html;
  box.querySelectorAll("[data-step]").forEach(b=>b.addEventListener("click",onStep));
  const sc=$("kwp_srCombine");
  if(sc) sc.addEventListener("change",e=>{
    const st=S.walls[S.active].sr;
    st.combine=e.target.checked; st.arr={}; st.mainSets=null; st.partnerSets=null;
    renderAll();
  });
}

/* =============== Extras =============== */
function warmthApplies(){
  const m=S.model;
  if(m.led==="integrated") return true;
  if(m.kind==="cosmic"){ const c=S.walls[S.active].cosmic.counts; return (c["0012"]+c["0212"])>0; }
  if(m.kind==="trinity") return true;
  return false;
}
function renderLed(){
  const box=$("kwp_ledbox");
  if(!warmthApplies()){ box.innerHTML=""; return; }
  const opts=["6000K","4000K","3000K","RGB"];
  const radios=(name,sel)=>opts.map(o=>`<label class="opt" style="display:inline-flex; margin-right:12px;"><input type="radio" name="${name}" value="${o}" ${sel===o?"checked":""}> <span style="margin-left:5px;">${o}${o==="6000K"?" · standard":""}</span></label>`).join("");
  box.innerHTML=`<div class="seglabel" style="margin-top:0;">LED light warmth</div>
    <div class="choice" style="margin-top:4px;">${radios("kwp_warmA",S.warmA)}</div>
    <label class="check" style="margin:10px 0 4px;"><input type="checkbox" id="kwp_cmp" ${S.compare?"checked":""}><span>Compare a second option in my quote</span></label>
    <div class="choice" style="margin-top:4px; ${S.compare?"":"display:none;"}">${radios("kwp_warmB",S.warmB||"3000K")}</div>
    <p class="hint">6000K is the standard. Other warmths and RGB are available on request and add 5–10 working days — detailed in your quote.</p>
    <hr style="border:none; border-top:1px solid var(--kwp-line); margin:14px 0;">`;
  box.querySelectorAll('input[name="kwp_warmA"]').forEach(x=>x.addEventListener("change",e=>{S.warmA=e.target.value; renderSummary();}));
  box.querySelectorAll('input[name="kwp_warmB"]').forEach(x=>x.addEventListener("change",e=>{S.warmB=e.target.value; renderSummary();}));
  $("kwp_cmp").addEventListener("change",e=>{S.compare=e.target.checked; if(S.compare&&!S.warmB)S.warmB="3000K"; renderLed(); renderSummary();});
}
function renderAccessories(){
  const m=S.model, box=$("kwp_accbox");
  let html="";
  if(m.acc){
    const wall=S.walls[S.active];
    if(m.acc.profile){
      const sug = wall.w? Math.ceil(wall.w/m.acc.profile.len):0;
      html+=`<div class="accrow"><div class="desc">${m.acc.profile.label}<small>Profiles join for longer runs or cut shorter. One run across your wall ≈ ${sug||"—"} pcs.</small></div>${stepper("accProfiles",S.accProfiles)}</div>`;
    }
    if(m.acc.projector){
      html+=`<div class="accrow"><div class="desc">${m.acc.projector.label}<small>Typically one per profile run.</small></div>${stepper("accProjectors",S.accProjectors)}</div>`;
    }
    html+=`<hr style="border:none; border-top:1px solid var(--kwp-line); margin:14px 0;">`;
  }
  box.innerHTML=html;
  box.querySelectorAll("[data-step]").forEach(b=>b.addEventListener("click",onStep));
}
function onStep(e){
  const k=e.currentTarget.dataset.key, d=+e.currentTarget.dataset.step, w=S.walls[S.active];
  if(k.indexOf("cosmic:")===0){ const sku=k.split(":")[1];
    w.cosmic.counts[sku]=Math.max(0,(w.cosmic.counts[sku]||0)+d); w.cosmic.placed=null; }
  else if(k==="sr:main"){ w.sr.mainSets=Math.max(0,(w.sr.mainSets||0)+d); w.sr.arr={}; }
  else if(k==="sr:part"){ w.sr.partnerSets=Math.max(0,(w.sr.partnerSets||0)+d); w.sr.arr={}; }
  else S[k]=Math.max(0,(S[k]||0)+d);
  renderAll();
}

/* =============== Openings UI =============== */
function renderOpenings(){
  const w=S.walls[S.active], box=$("kwp_openinglist");
  box.innerHTML = w.open.map((o,i)=>`<div class="openrow" data-oi="${i}">
    <div class="row">
      <div><label>Opening ${i+1} width (m)</label><input type="number" data-of="w" min="0.2" step="0.05" value="${o.w}"></div>
      <div><label>Height (m)</label><input type="number" data-of="h" min="0.2" step="0.05" value="${o.h}"></div>
      <button class="del" type="button" data-del="${i}">remove</button>
    </div>
  </div>`).join("");
  $("kwp_addopening").style.display = w.open.length>=3 ? "none":"";
  $("kwp_openhint").style.display = w.open.length? "":"none";
  box.querySelectorAll("input").forEach(inp=>inp.addEventListener("input",e=>{
    const i=+e.target.closest(".openrow").dataset.oi, f=e.target.dataset.of;
    w.open[i][f]=parseFloat(e.target.value)||0;
    clampOpening(w, w.open[i]); w.cosmic.placed=null; clearCellMaps(w);
    renderAll();
  }));
  box.querySelectorAll("[data-del]").forEach(b=>b.addEventListener("click",e=>{ w.open.splice(+e.currentTarget.dataset.del,1); w.cosmic.placed=null; clearCellMaps(w); renderAll(); }));
}
function clampOpening(w,o){
  o.x=Math.min(Math.max(0,o.x),Math.max(0,(+w.w||0)-o.w));
  o.y=Math.min(Math.max(0,o.y),Math.max(0,(+w.h||0)-o.h));
}

/* =============== Summary =============== */
function sline(k,v){ return `<div class="sline"><span>${k}</span><span class="v">${v}</span></div>`; }
function renderSummary(){
  const t=totals(), m=S.model, w=S.walls[S.active];
  if(!t.valid){ $("kwp_s_count").textContent="—"; $("kwp_s_countnote").textContent="Enter wall dimensions to see your panel count."; $("kwp_s_lines").innerHTML=""; $("kwp_gotoquote").disabled=true; kwpSetToolButtons(false); $("kwp_cuthint").textContent=""; return; }
  $("kwp_s_count").innerHTML=`${t.finalN} <small>panels</small>`;
  $("kwp_s_countnote").textContent = m.kind==="trinity" ? `${t.pkgs} sets of 3 + ${t.pkgs} triangle elements · covers ${t.area.toFixed(1)} m²`
    : m.kind==="surfrip" ? (t.srPart? `${t.srMain} ${m.name.split(" ")[0]} sets + ${t.srPart} ${modelById(m.partner).name.split(" ")[0]} sets · covers ${t.area.toFixed(1)} m²` : `${t.srMain} sets of ${m.setSize} · covers ${t.area.toFixed(1)} m²`)
    : m.pkg>1 ? `${t.pkgs} ${m.set2?"sets":"packs"} of ${m.pkg} · covers ${t.area.toFixed(1)} m²` : `covers ${t.area.toFixed(1)} m²`;
  let L="";
  // Panel dimensions for reference (orientation-aware for AQUA/CURVE/INCA/ORIGAMI).
  const oe=effOrient(m);
  const dimStr = m.kind==="cosmic" ? "60 × 60 &amp; 30 × 30 cm"
    : `${Math.round(effW(m)*100)} × ${Math.round(effH(m)*100)} cm${oe?` <small>${oe.o==="v"?"vertical":"horizontal"} placement</small>`:""}`;
  L+=sline("Panel size", dimStr);
  if(t.perWall.length>1) t.perWall.forEach(pw=>{ L+=`<div class="sline wall"><span>${pw.label}</span><span class="v">${pw.txt}</span></div>`; });
  if(m.kind==="cosmic"){
    const c=S.walls.reduce((acc,x)=>{Object.keys(x.cosmic.counts).forEach(k=>acc[k]=(acc[k]||0)+x.cosmic.counts[k]);return acc;},{});
    ["0012","0312","0212","0412"].forEach(k=>{ if(c[k]) L+=sline("COSMIC "+k, c[k]); });
    if(t.cut) L+=sline("Cut fill panels", t.cut+" <small>optional edge fill, non-LED</small>");
  } else {
    L+=sline("Panels needed", t.n + (m.set2?` (${Math.ceil(t.n/2)} sets)`:""));
    if(t.cut>0) L+=sline("Cut on site", t.cut + (m.set2?" <small>non-LED panels take the cuts</small>":""));
    if(S.fillMode==="full" && (m.kind==="grid"||m.kind==="hex"||m.kind==="trinity"||m.kind==="surfrip")) L+=sline("Cutting","none <small>full panels only — edges stay painted</small>");
  }
  if(m.kind==="trinity"){
    L+=sline("Triangle LED elements", `${t.pkgs} included <small>1 per set — positioned on site</small>`);
    if(S.triExtra>0) L+=sline("Extra triangle elements", `+${S.triExtra} <small>on request — priced separately</small>`);
  }
  if(m.kind==="surfrip" && t.srPart){
    L+=sline(m.name.split(" ")[0]+" sets", `${t.srMain} × ${m.setSize} panels`);
    L+=sline(modelById(m.partner).name.split(" ")[0]+" sets", `${t.srPart} × ${modelById(m.partner).setSize} panels`);
    if(t.srUnplaced) L+=sline("Don't fit this wall", t.srUnplaced+" <small>reduce sets or enlarge the wall</small>");
    if(t.srPainted) L+=sline("Spots left painted", t.srPainted);
  }
  if(t.offN) L+=sline("Spots left empty", t.offN+" <small>stay painted — click to fill them back</small>");
  if(t.spillN) L+=sline("5 % reserve","+"+t.spillN);
  if(t.finalN>t.gross) L+=sline("Rounded to full "+(m.kind==="trinity"||m.set2?"sets":"packs"),"+"+(t.finalN-t.gross));
  if(warmthApplies()) L+=sline("LED warmth", S.compare? `${S.warmA} + ${S.warmB} <small>two options quoted</small>` : S.warmA);
  if(m.acc&&S.accProfiles) L+=sline("LED profiles",S.accProfiles);
  if(m.acc&&m.acc.projector&&S.accProjectors) L+=sline("Projectors",S.accProjectors);
  const opens=S.walls.reduce((a,x)=>a+x.open.length,0);
  if(opens) L+=sline("Openings deducted",opens);
  L+=sline("Approx. shipping weight","~"+t.kg+" kg <small>ships on protected pallets</small>");
  $("kwp_s_lines").innerHTML=L;
  $("kwp_gotoquote").disabled=false;
  kwpSetToolButtons(true);
  $("kwp_cuthint").textContent = cutHintText(w,m);
}
function kwpSetToolButtons(on){
  var sb=$("kwp_share"), db=$("kwp_dossier");
  if(sb) sb.disabled=!on;
  if(db) db.disabled=!on;
}
function cutHintText(w,m){
  if(m.step){
    const r=cellsStep(w,m); if(!r) return "";
    if(r.full) return "Full strips only — nothing is cut; the stepped gaps stay painted.";
    const cut=r.cells.filter(c=>c.cut).length;
    return cut? `${cut} of ${r.cells.length} strips on this wall will be cut to size.` : "Every strip is full — no cutting needed.";
  }
  if(m.kind==="grid"){
    const r=cellsGrid(w,m); if(!r) return "";
    const act=r.cells.filter(c=>!c.off);
    if(r.full) return "Full panels only — nothing is cut; uncovered edges stay painted"+(w.open.length?", and panels overlapping openings are left out.":".");
    const cut=act.filter(c=>c.cut).length;
    return cut? `${cut} of ${act.length} panels on this wall will be cut.` : "This wall fits full panels exactly — no cutting needed.";
  }
  if(m.kind==="trinity"){
    const r=cellsTrinity(w,m); if(!r) return "";
    if(r.full) return "Full panels only — nothing is cut; uncovered edges stay painted.";
    const cut=r.cells.filter(c=>c.cut).length;
    return cut? `${cut} of ${r.total} squares on this wall will be cut.` : "This wall fits full squares exactly — no cutting needed.";
  }
  if(m.kind==="hex"){
    const r=hexCells(w,m); if(!r) return "";
    const cut=r.act.filter(c=>c.cut).length;
    return S.fillMode==="full" ? "Full hexagons only — edges stay painted." : (cut? `${cut} of ${r.act.length} hexagons will be trimmed on site.` : "No trimming needed.");
  }
  if(m.kind==="surfrip"){
    const r=cellsSurfRip(w,m); if(!r) return "";
    if(r.full) return "Full panels only — nothing is cut; uncovered edges stay painted.";
    const cut=r.assigned.filter(c=>c.cut).length;
    return cut? `${cut} of ${r.assigned.length} panels on this wall will be cut.` : "This wall fits full panels exactly — no cutting needed.";
  }
  if(m.kind==="area") return "Mosaic set — counted by covered area.";
  return "";
}

/* =============== Walls tabs =============== */
function renderWallTabs(){
  const t=$("kwp_walltabs");
  t.innerHTML = S.walls.map((w,i)=>`<button type="button" class="walltab ${i===S.active?"active":""}" data-i="${i}">Wall ${wallLetter(i)}${S.walls.length>1?`<span class="x" data-del="${i}" title="Remove">×</span>`:""}</button>`).join("")
    + `<button type="button" class="ghostbtn" id="kwp_addwallbtn">+ Add another wall</button>`;
  t.querySelectorAll(".walltab").forEach(b=>b.addEventListener("click",e=>{
    if(e.target.dataset.del!==undefined){ S.walls.splice(+e.target.dataset.del,1); S.active=0; renderAll(); return; }
    S.active=+b.dataset.i; renderAll();
  }));
  $("kwp_addwallbtn").addEventListener("click",()=>{ S.walls.push(newWall()); S.active=S.walls.length-1; renderAll(); $("kwp_ww").focus(); });
  const w=S.walls[S.active];
  $("kwp_ww").value=w.w||""; $("kwp_wh").value=w.h||""; $("kwp_skirt").value=S.skirt||"";
}

/* =============== Quote form (native Shopify contact submit) =============== */
function trackEvent(name){
  try{
    if(window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish){
      window.Shopify.analytics.publish(name, {locale: LOCALE});
    }
  }catch(e){}
  try{
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event: name});
    if(typeof window.gtag === "function"){ window.gtag("event", name); }
  }catch(e){}
}
function buildLeadText(){
  var t=totals(), m=S.model;
  var lines=["Wall planner quote request", "Model: "+m.name+" (SKU "+(m.sku||m.id)+")", ""];
  kwpScheduleRows(t).forEach(function(r){ lines.push(r[0]+": "+r[1]); });
  lines.push("");
  try{ lines.push("Open this exact wall (interactive): "+buildShareUrl()); }catch(e){}
  lines.push("Sent from: "+window.location.href.split("#")[0]);
  return lines.join("\n");
}
/* ---- Layout snapshots: rasterize each wall's preview (as the customer arranged
       it) to JPEG for the downloadable wall dossier PDF. ---- */
var tileDataCache = {};
function inlineTiles(svgNode){
  var imgs = svgNode.querySelectorAll("defs image");
  return Promise.all([].map.call(imgs, function(imEl){
    var href = imEl.getAttribute("href");
    if(!href || href.indexOf("data:")===0) return Promise.resolve();
    if(tileDataCache[href]){ imEl.setAttribute("href", tileDataCache[href]); return Promise.resolve(); }
    return fetch(href, {mode:"cors"}).then(function(r){ return r.ok ? r.blob() : Promise.reject(); }).then(function(b){
      return new Promise(function(res){
        var fr = new FileReader();
        fr.onload = function(){ tileDataCache[href]=fr.result; imEl.setAttribute("href", fr.result); res(); };
        fr.onerror = function(){ res(); };
        fr.readAsDataURL(b);
      });
    }).catch(function(){ /* tile stays external; that panel renders blank in the snapshot */ });
  }));
}
function captureWall(i){
  return new Promise(function(resolve){
    var prev = S.active;
    function restore(){ S.active = prev; renderPreview(); }
    S.active = i; renderPreview();
    var svg = svgEl();
    if(!svg){ restore(); resolve(null); return; }
    var clone = svg.cloneNode(true);
    // Snapshots are documents, not UI: drop the interactive-only affordances
    // (the ×/+ leave-empty targets and the "drag me" hint on openings).
    try{
      [].forEach.call(clone.querySelectorAll("[data-kwp-off]"), function(g){ g.parentNode.removeChild(g); });
      [].forEach.call(clone.querySelectorAll("[data-open] text"), function(tx){
        tx.textContent = tx.textContent.replace(/\s*·.*$/, "");
      });
    }catch(e){}
    inlineTiles(clone).then(function(){
      var vb = svg.viewBox.baseVal, scale = 2;
      var kwpCS = getComputedStyle(ROOT);
      function kwpVar(n, fb){ var v=(kwpCS.getPropertyValue(n)||"").trim(); return v||fb; }
      var xml = new XMLSerializer().serializeToString(clone)
        .replace(/var\(--kwp-wall-bg\)/g, kwpVar("--kwp-wall-bg", "#edebe7"))
        .replace(/var\(--kwp-panel-face\)/g, kwpVar("--kwp-panel-face", "#faf9f7"))
        .replace(/var\(--kwp-panel-edge\)/g, kwpVar("--kwp-panel-edge", "#d9d5cf"))
        .replace(/var\(--kwp-grey\)/g, kwpVar("--kwp-grey", "#737373"));
      var img = new Image();
      img.onload = function(){
        var data = null;
        try{
          var c = document.createElement("canvas");
          c.width = Math.round(vb.width*scale); c.height = Math.round(vb.height*scale);
          var ctx = c.getContext("2d");
          ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height);
          ctx.drawImage(img, 0, 0, c.width, c.height);
          data = c.toDataURL("image/jpeg", 0.85);
        }catch(e){ /* tainted canvas or serialize issue — skip snapshot */ }
        restore(); resolve(data);
      };
      img.onerror = function(){ restore(); resolve(null); };
      img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(xml);
    });
  });
}
function captureAllWalls(){
  var idx = [];
  S.walls.forEach(function(w,i){ if(+w.w && +w.h) idx.push(i); });
  idx = idx.slice(0, 4);
  var out = [];
  var chain = Promise.resolve();
  idx.forEach(function(i){
    chain = chain.then(function(){
      return captureWall(i).then(function(d){ if(d) out.push({wall: wallLetter(i), data: d}); });
    });
  });
  var timeout = new Promise(function(res){ setTimeout(function(){ res("timeout"); }, 8000); });
  return Promise.race([chain.then(function(){ return "done"; }), timeout]).then(function(){ return out; });
}

/* Postal-code shape per country code; format-level only. With a free-text country
   field these match only when the visitor's country maps to a known code, otherwise
   a generic length check applies. */
const KWP_ZIP_PATTERNS={DE:/^\d{5}$/,FR:/^\d{5}$/,IT:/^\d{5}$/,ES:/^\d{5}$/,AT:/^\d{4}$/,BE:/^\d{4}$/,CH:/^\d{4}$/,NL:/^\d{4}\s?[A-Za-z]{2}$/};
const KWP_ZIP_HINTS={DE:"5 digits, e.g. 10115",FR:"5 digits, e.g. 75008",IT:"5 digits, e.g. 20121",ES:"5 digits, e.g. 28001",AT:"4 digits, e.g. 1010",BE:"4 digits, e.g. 1000",CH:"4 digits, e.g. 8005",NL:"e.g. 1012 AB"};
function kwpZipOk(country,zip){
  const re=KWP_ZIP_PATTERNS[country];
  return re ? re.test(zip) : zip.length>=2 && zip.length<=12;
}

function bindForm(){
  ROOT.querySelectorAll(".segcard").forEach(c=>c.addEventListener("click",()=>{
    S.seg=c.dataset.seg;
    ROOT.querySelectorAll(".segcard").forEach(x=>x.classList.toggle("on",x===c));
    $("kwp_company_row").classList.toggle("hidden",S.seg!=="professional");
    $("kwp_f_company").required = S.seg==="professional";
  }));
  function validateZipField(){
    const zipEl=$("kwp_f_zip"), c=$("kwp_f_country").value, v=zipEl.value.trim();
    zipEl.setCustomValidity(v && c && !kwpZipOk(c,v)
      ? "Please enter a valid postal code"+(KWP_ZIP_HINTS[c]?" ("+KWP_ZIP_HINTS[c]+")":"")
      : "");
  }
  $("kwp_f_country").addEventListener("change",validateZipField);
  $("kwp_f_zip").addEventListener("input",validateZipField);


  $("kwp_gotoquote").addEventListener("click",()=>{
    $("kwp_inputcol").classList.add("hidden");
    $("kwp_formcol").classList.remove("hidden");
    ROOT.scrollIntoView({behavior:"smooth", block:"start"});
  });
  $("kwp_backtoplan").addEventListener("click",()=>{
    $("kwp_formcol").classList.add("hidden");
    $("kwp_inputcol").classList.remove("hidden");
  });

  const form=$("kwp_form");
  form.addEventListener("submit", e=>{
    validateZipField();
    if(!form.checkValidity()){ e.preventDefault(); form.reportValidity(); return; }
    // Honeypot: bots that fill the hidden field are dropped silently.
    if(form.querySelector('[name="kwp_x1"]').value){ e.preventDefault(); return; }
    var segEl=$("kwp_f_segment"); if(segEl) segEl.value = S.seg==="professional" ? "Professional" : "Private";
    var bodyEl=$("kwp_body"); if(bodyEl) bodyEl.value = buildLeadText();
    // Shopify redirects back after the POST; carrying the share fragment in
    // return_to restores this exact wall so the dossier stays downloadable.
    var ret=form.querySelector('[name="return_to"]');
    if(ret){ try{ ret.value = window.location.pathname + "#" + buildShareUrl().split("#")[1]; }catch(err){} }
    trackEvent("planner_quote_request");
    var btn=$("kwp_submit"); btn.disabled=true; btn.textContent="Sending…";
    // The native POST to /contact now proceeds: Shopify handles delivery to the
    // store's sender email, its spam checks, and any captcha challenge page.
  });
}

/* =============== Share button (play #1) =============== */
var kwpToolMsgTimer=null;
function kwpToolMsg(txt){
  var el=$("kwp_toolmsg"); if(!el) return;
  el.textContent=txt; el.hidden=false;
  clearTimeout(kwpToolMsgTimer);
  kwpToolMsgTimer=setTimeout(function(){ el.hidden=true; }, 4500);
}
function kwpCopyShare(url){
  function done(ok){ kwpToolMsg(ok ? "Link copied — paste it anywhere to reopen this exact wall."
                                   : "Could not copy automatically — the link is in your address bar."); }
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(url).then(function(){ done(true); }, function(){ done(false); });
  } else done(false);
}
function bindShare(){
  var btn=$("kwp_share"); if(!btn) return;
  btn.addEventListener("click", function(){
    if(btn.disabled) return;
    var url=buildShareUrl();
    // Reflect the link in the address bar too — the copy fallback relies on it.
    try{ history.replaceState(null, "", "#"+url.split("#")[1]); }catch(e){}
    trackEvent("wall_shared");
    if(navigator.share && window.matchMedia && window.matchMedia("(pointer: coarse)").matches){
      navigator.share({title:"Kandes wall plan", text:"My Kandes wall plan — "+S.model.name, url:url})
        .catch(function(err){ if(!err || err.name!=="AbortError") kwpCopyShare(url); });
      return;
    }
    kwpCopyShare(url);
  });
}

/* =============== Wall dossier PDF (play #2) ===============
   Client-side branded PDF via the vendored jsPDF theme asset (kandes-jspdf.js),
   lazy-loaded on first click — no backend. Layout drawings reuse captureWall()
   so the customer's exact arrangement (incl. the taupe cut-hatch) lands in the
   document. NO prices anywhere in the dossier — policy. */
var KWP_DOSSIER_LINKS={
  dop:"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes-3D-Gypsum-Panels-CE-Declaration-of-Performance.pdf?v=1783808484",
  catalogue:"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Technical_Catalogue_July2026.pdf?v=1783808485",
  certs:"https://kandes.eu/pages/downloads-certifications",
  logo:"https://kandes.eu/cdn/shop/files/Kandes_logo_large_a946ef0f-f1e3-4b8b-a750-a72ec5ffa4c6.png?v=1738836956&width=326",
  sheets:{"0011":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_LED_PROJECTOR_0011.pdf?v=1783809834","0012":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_COSMIC_LED_LARGE_0012.pdf?v=1783809838","0015":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_GRID_LED_0015.pdf?v=1783809841","0017":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_LED_PROFILE_0017.pdf?v=1783809842","0018":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_AQUA_LED_0018.pdf?v=1783809845","0021":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_TRINITY_LED_0021.pdf?v=1783809849","0023":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ZANZI_0023.pdf?v=1783809853","0024":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ORIGAMI_0024.pdf?v=1783809854","0025":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ZIGZAG_0025.pdf?v=1783809856","0034":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_CHOPPY_0034.pdf?v=1783809859","0035":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_GEON_LED_0035.pdf?v=1783809862","0038":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ENIGMA_0038.pdf?v=1783809864","0039":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_BUMBLE_0039.pdf?v=1783809866","0040":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_NOVA_0040.pdf?v=1783809870","0041":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SALT_0041.pdf?v=1783809872","0042":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_FUTUR_LED_0042.pdf?v=1783809875","0043":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_FACET_0043.pdf?v=1783809877","0044":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_HIVE_0044.pdf?v=1783809879","0045":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_HEXAGON_LED_0045.pdf?v=1783809882","0046":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SOAP_0046.pdf?v=1783809884","0048":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SAHARA_0048.pdf?v=1783809887","0050":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_RIDGE_0050.pdf?v=1783809889","0051":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_BLOCKS_0051.pdf?v=1783809891","0052":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_METEOR_0052.pdf?v=1783809894","0053":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_FOAM_0053.pdf?v=1783809896","0055":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_BAROQUE_0055.pdf?v=1783809899","0057":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_WOOD_0057.pdf?v=1783809901","0058":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_WAVES_0058.pdf?v=1783809905","0064":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_FLARE_0064.pdf?v=1783809907","0072":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_GROOVE_0072.pdf?v=1783809910","0073":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SLATE_LED_0073.pdf?v=1783809912","0075":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ORIENT_0075.pdf?v=1783809916","0076":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_RIPPLE_0076.pdf?v=1783809917","0077":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SURF_0077.pdf?v=1783809920","0078":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_DUNE_0078.pdf?v=1783809922","0079":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_PUNTO_0079.pdf?v=1783809924","0081":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_PIXEL_0081.pdf?v=1783809927","0082":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_INCA_0082.pdf?v=1783809930","0085":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_CURVE_LED_0085.pdf?v=1783809932","0088":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_MARIS_0088.pdf?v=1783809935","0093":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SOOTHE_0093.pdf?v=1783809938","0096":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_BRICK_0096.pdf?v=1783809940","0097":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_DRIFT_0097.pdf?v=1783809942","0099":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_BUTTON_0099.pdf?v=1783809946","0106":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SANDY_0106.pdf?v=1783809948","0111":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_FLOW_0111.pdf?v=1783809950","0112":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_LIGNEO_LED_0112.pdf?v=1783809953","0113":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_PEBBLE_0113.pdf?v=1783809956","0114":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_CASCADE_LED_0114.pdf?v=1783809958","0115":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_WEAVE_0115.pdf?v=1783809963","0118":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ROMBO_0118.pdf?v=1783809964","0120":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SCALE_0120.pdf?v=1783809967","0123":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_BLOOM_0123.pdf?v=1783809968","0124":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ASTI_0124.pdf?v=1783809971","0125":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_SATIN_0125.pdf?v=1783809973","0129":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_PRISMA_0129.pdf?v=1783809975","0132":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_PLUSH_0132.pdf?v=1783809977","0135":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_GLYPHO_0135.pdf?v=1783809981","0136":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_MYSTIC_0136.pdf?v=1783809983","0139":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_NOBILIS_0139.pdf?v=1783809985","0145":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_NEXUS_0145.pdf?v=1783809987","0147":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_FOLIUM_0147.pdf?v=1783809991","0150":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ORNATA_0150.pdf?v=1783809994","0212":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_COSMIC_LED_MEDIUM_0212.pdf?v=1783809995","0312":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_COSMIC_LARGE_0312.pdf?v=1783809998","0395":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_ALUMINIUM_PROFILE_0395.pdf?v=1783809999","0412":"https://cdn.shopify.com/s/files/1/0916/6192/6724/files/Kandes_Data_Sheet_COSMIC_MEDIUM_0412.pdf?v=1783810001"}
};
var kwpJsPdfPromise=null;
function kwpLoadJsPDF(){
  if(window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
  if(kwpJsPdfPromise) return kwpJsPdfPromise;
  var src=ROOT.getAttribute("data-kandes-jspdf");
  kwpJsPdfPromise=new Promise(function(res,rej){
    if(!src){ rej(new Error("no jspdf src")); return; }
    var sc=document.createElement("script");
    sc.src=src; sc.async=true;
    sc.onload=function(){ if(window.jspdf&&window.jspdf.jsPDF) res(window.jspdf.jsPDF); else rej(new Error("jspdf missing")); };
    sc.onerror=function(){ kwpJsPdfPromise=null; rej(new Error("jspdf load failed")); };
    document.head.appendChild(sc);
  });
  return kwpJsPdfPromise;
}
var kwpLogoData;
function kwpFetchLogo(){
  if(kwpLogoData!==undefined) return Promise.resolve(kwpLogoData);
  return fetch(KWP_DOSSIER_LINKS.logo,{mode:"cors"})
    .then(function(r){ return r.ok? r.blob() : Promise.reject(); })
    .then(function(b){ return new Promise(function(res){
      var fr=new FileReader();
      fr.onload=function(){ kwpLogoData=fr.result; res(kwpLogoData); };
      fr.onerror=function(){ kwpLogoData=null; res(null); };
      fr.readAsDataURL(b);
    }); })
    .catch(function(){ kwpLogoData=null; return null; });
}
function kwpSpecFor(m){
  var SP=window.KWP_SPECS||{};
  return SP[m.sku]||SP[m.id]||null;
}
function kwpDateISO(){
  var d=new Date();
  return d.getFullYear()+"-"+String(d.getMonth()+1).padStart(2,"0")+"-"+String(d.getDate()).padStart(2,"0");
}
function kwpDateStr(){
  var M=["January","February","March","April","May","June","July","August","September","October","November","December"];
  var d=new Date(); return d.getDate()+" "+M[d.getMonth()]+" "+d.getFullYear();
}
function kwpScheduleRows(t){
  var m=S.model, rows=[];
  rows.push(["Model", m.name]);
  S.walls.forEach(function(w,i){
    if(!(+w.w&&+w.h)) return;
    var otxt=w.open.length? " · "+w.open.length+" opening"+(w.open.length>1?"s":"") : "";
    rows.push(["Wall "+wallLetter(i), (+w.w).toFixed(2)+" × "+(+w.h).toFixed(2)+" m"+otxt]);
  });
  if(S.skirt) rows.push(["Skirting board", S.skirt+" cm — panels start above it"]);
  rows.push(["Panelled area", t.area.toFixed(1)+" m²"]);
  if(m.kind!=="area" && m.kind!=="cosmic"){
    rows.push(["Coverage mode", S.fillMode==="full" ? "Full panels only — uncovered edges stay painted" : "Fill the wall — edge panels cut to size"]);
  }
  if(m.kind==="cosmic"){
    var c=S.walls.reduce(function(acc,x){ Object.keys(x.cosmic.counts).forEach(function(k){ acc[k]=(acc[k]||0)+x.cosmic.counts[k]; }); return acc; },{});
    ["0012","0312","0212","0412"].forEach(function(k){ if(c[k]) rows.push(["COSMIC "+k, String(c[k])]); });
    if(t.cut) rows.push(["Cut fill panels", t.cut+" — optional edge fill, non-LED"]);
  } else {
    rows.push(["Panels", String(t.n)+(m.set2? " ("+Math.ceil(t.n/2)+" sets of 2)":"")]);
    if(t.cut>0) rows.push(["Cut on site", String(t.cut)+(m.set2? " — non-LED panels take the cuts":"")]);
    else if(S.fillMode!=="full" && m.kind!=="area") rows.push(["Cut on site", "none — full panels fit exactly"]);
  }
  if(t.offN) rows.push(["Spots left empty", t.offN+" — stay painted"]);
  if(m.kind==="surfrip" && t.srPart){
    var pn=modelById(m.partner);
    rows.push([m.name.split(" ")[0]+" sets", t.srMain+" × "+m.setSize+" panels"]);
    rows.push([pn.name.split(" ")[0]+" sets", t.srPart+" × "+pn.setSize+" panels"]);
    if(t.srPainted) rows.push(["Spots left painted", String(t.srPainted)]);
  }
  if(t.spillN) rows.push(["5 % cutting & handling reserve", "+"+t.spillN]);
  if(t.finalN>t.gross) rows.push(["Rounded to full "+(m.kind==="trinity"||m.set2?"sets":"packs"), "+"+(t.finalN-t.gross)]);
  rows.push(["Total panels", String(t.finalN)+(m.kind==="trinity" ? " ("+t.pkgs+" sets of 3)"
    : (m.pkg>1 ? " ("+t.pkgs+" "+(m.set2?"sets":"packs")+" of "+m.pkg+")" : ""))]);
  if(m.kind==="trinity"){
    rows.push(["Triangle LED elements", t.pkgs+" included — 1 per set, positioned on site"]);
    if(S.triExtra) rows.push(["Additional triangle elements", "+"+S.triExtra+" on request"]);
  }
  if(warmthApplies()) rows.push(["LED warmth", S.compare? S.warmA+" + "+S.warmB+" — two options to quote" : S.warmA+(S.warmA==="6000K"?" (standard)":"")]);
  if(m.acc&&S.accProfiles) rows.push(["LED profiles", String(S.accProfiles)]);
  if(m.acc&&m.acc.projector&&S.accProjectors) rows.push(["LED projectors", String(S.accProjectors)]);
  rows.push(["Approx. shipping weight", "~"+t.kg+" kg — ships on protected pallets"]);
  return rows;
}
function kwpComposeDossier(JsPDF, logo, images){
  var m=S.model, t=totals();
  var doc=new JsPDF({unit:"mm", format:"a4", compress:true});
  var PW=210, PH=297, ML=18, CW=PW-36;
  var INK=[23,23,23], MAUVE=[115,95,95], GREY=[115,115,115], TAUPE=[174,158,152],
      YELLOW=[255,210,48], LINE=[231,228,225];
  function tc(c){ doc.setTextColor(c[0],c[1],c[2]); }
  function dc(c){ doc.setDrawColor(c[0],c[1],c[2]); }
  function fc(c){ doc.setFillColor(c[0],c[1],c[2]); }
  var y=18;
  function pageBreak(need){ if(y+need>PH-22){ doc.addPage(); y=18; } }
  function h2(txt){
    pageBreak(18); y+=6;
    doc.setFont("helvetica","bold"); doc.setFontSize(10.5); tc(INK);
    doc.text(txt.toUpperCase(), ML, y);
    dc(YELLOW); doc.setLineWidth(0.9); doc.line(ML, y+1.8, ML+10, y+1.8);
    y+=7;
  }
  function para(txt, size, color){
    doc.setFont("helvetica","normal"); doc.setFontSize(size||9.5); tc(color||INK);
    var lh=(size||9.5)*0.46;
    doc.splitTextToSize(txt, CW).forEach(function(ln){ pageBreak(lh+2); doc.text(ln, ML, y); y+=lh; });
  }
  function rowPair(label, value){
    doc.setFont("helvetica","normal"); doc.setFontSize(9);
    var vls=doc.splitTextToSize(String(value), CW-60);
    var rh=Math.max(1,vls.length)*4.1+2.6;
    pageBreak(rh+1);
    tc(MAUVE); doc.text(String(label), ML, y+3.4);
    doc.setFont("helvetica","bold"); tc(INK);
    vls.forEach(function(vl,i2){ doc.text(vl, ML+CW, y+3.4+i2*4.1, {align:"right"}); });
    y+=rh;
    dc(LINE); doc.setLineWidth(0.2); doc.line(ML, y, ML+CW, y);
    y+=0.8;
  }

  /* 1 — header */
  if(logo){ try{ doc.addImage(logo, "PNG", ML, y-5, 12, 12); }catch(e){ logo=null; } }
  var hx=logo? ML+16 : ML;
  doc.setFont("helvetica","bold"); doc.setFontSize(17); tc(INK);
  doc.text("KANDES", hx, y+1);
  doc.setFont("helvetica","normal"); doc.setFontSize(9); tc(MAUVE);
  // Swissness (MSchG Art. 47/48): "Swiss" must never attach to the product noun —
  // the panels are EU-produced. Detached lockup form, per the approved store name
  // "Kandes | Swiss Brand · 3D Wall Panels" (fixed 20 Jul 2026).
  doc.text("Swiss brand · 3D gypsum wall panels", hx, y+5.6);
  doc.setFont("helvetica","bold"); doc.setFontSize(11); tc(INK);
  doc.text("WALL DOSSIER", ML+CW, y+1, {align:"right"});
  doc.setFont("helvetica","normal"); doc.setFontSize(9); tc(GREY);
  doc.text(kwpDateStr(), ML+CW, y+5.6, {align:"right"});
  y+=10;
  fc(YELLOW); doc.rect(ML, y, CW, 1.1, "F");
  y+=6;
  var share=buildShareUrl();
  doc.setFontSize(8); tc(MAUVE);
  doc.text("Open this exact wall online (interactive):", ML, y); y+=3.6;
  doc.setFontSize(6.5); tc(GREY);
  var urlLines=doc.splitTextToSize(share, CW);
  var shown=urlLines.slice(0,4);
  if(urlLines.length>4) shown[3]=shown[3].slice(0,-2)+"…";
  shown.forEach(function(ln){ doc.textWithLink(ln, ML, y, {url:share}); y+=2.8; });
  y+=1.5;

  /* 2 — layout drawing */
  h2("Layout drawing");
  var capDims={};
  S.walls.forEach(function(w,i){ if(+w.w&&+w.h) capDims[wallLetter(i)]=(+w.w).toFixed(2)+" × "+(+w.h).toFixed(2)+" m"; });
  if(images && images.length){
    var two=images.length>1;
    var slotW=two? (CW-6)/2 : Math.min(CW,150);
    var x=ML, rowH=0, inRow=0;
    images.forEach(function(im){
      var pr; try{ pr=doc.getImageProperties(im.data); }catch(e){ return; }
      var drawW=slotW, drawH=slotW*pr.height/pr.width;
      var maxH=two? 92 : 108;
      if(drawH>maxH){ drawW=drawW*maxH/drawH; drawH=maxH; }
      var cap="Wall "+im.wall+(capDims[im.wall]? " · "+capDims[im.wall] : "");
      if(!two){
        pageBreak(drawH+10);
        doc.addImage(im.data, "JPEG", ML+(CW-drawW)/2, y, drawW, drawH);
        y+=drawH+4;
        doc.setFont("helvetica","normal"); doc.setFontSize(8.5); tc(GREY);
        doc.text(cap, ML+CW/2, y, {align:"center"});
        y+=5;
      } else {
        if(inRow===0){ pageBreak(drawH+12); rowH=0; x=ML; }
        doc.addImage(im.data, "JPEG", x+(slotW-drawW)/2, y, drawW, drawH);
        doc.setFont("helvetica","normal"); doc.setFontSize(8.5); tc(GREY);
        doc.text(cap, x+slotW/2, y+drawH+4, {align:"center"});
        rowH=Math.max(rowH, drawH);
        inRow++;
        if(inRow===2){ y+=rowH+9; inRow=0; } else { x=ML+slotW+6; }
      }
    });
    if(inRow===1) y+=rowH+9;
  } else {
    para("The layout drawing could not be rendered in this browser — your quote will include the true-to-design layout drawing.", 9, GREY);
    y+=2;
  }

  /* 3 — panel schedule */
  h2("Panel schedule");
  kwpScheduleRows(t).forEach(function(r){ rowPair(r[0], r[1]); });

  /* 4 — model specification */
  h2("Model specification");
  var sp=kwpSpecFor(m);
  var specRows=[["Model", m.name]];
  if(m.kind==="cosmic"){
    specRows.push(["Panel sizes", "60 × 60 cm (large) · 30 × 30 cm (medium)"]);
    specRows.push(["Thickness", (sp&&sp.th)||"30 mm"]);
    specRows.push(["Weight per panel", "5 kg (large) · 2.5 kg (medium)"]);
  } else if(sp){
    specRows.push(["Panel size", sp.sz]);
    specRows.push(["Thickness", sp.th]);
    specRows.push(["Weight per panel", sp.wt]);
    specRows.push(["Panels per m²", sp.m2]);
  }
  specRows.push(["Material", "Reinforced natural gypsum — no harmful additives"]);
  specRows.push(["Finish", "Supplied unfinished — primed and painted on site in any colour"]);
  // Keeps the produced-in-EU disclosure in view of the "Swiss brand" lockup above,
  // which is the condition the Swissness allowlist attaches to that term.
  specRows.push(["Production", "Produced in the European Union"]);
  specRows.forEach(function(r){ rowPair(r[0], r[1]); });
  y+=1.5; pageBreak(6);
  doc.setFont("helvetica","normal"); doc.setFontSize(8.5); tc(MAUVE);
  var kwpSheetUrl=(KWP_DOSSIER_LINKS.sheets&&KWP_DOSSIER_LINKS.sheets[(m&&m.sku)||""])||KWP_DOSSIER_LINKS.catalogue;
  doc.textWithLink(kwpSheetUrl===KWP_DOSSIER_LINKS.catalogue?"Full specification for all models: Technical Catalogue (PDF)":"Full technical data sheet for this model (PDF)", ML, y, {url:kwpSheetUrl});
  y+=4.4;
  if(sp && sp.led){
    y+=2; pageBreak(18);
    doc.setFont("helvetica","bold"); doc.setFontSize(9); tc(INK);
    doc.text("LED lighting on this model", ML, y+3.2); y+=6.6;
    para(sp.led, 9, INK);
    y+=1;
  }

  /* 5 — fire classification */
  h2("Fire classification");
  para("A1 non-combustible (EN 13501-1) — the highest fire rating under European fire safety standards.", 9.5, INK);
  y+=2; pageBreak(10);
  doc.setFont("helvetica","normal"); doc.setFontSize(8.5); tc(MAUVE);
  doc.textWithLink("Declaration of Performance (CE, signed) — download the PDF", ML, y, {url:KWP_DOSSIER_LINKS.dop});
  y+=4.4;
  doc.textWithLink("All certificates: kandes.eu/pages/downloads-certifications", ML, y, {url:KWP_DOSSIER_LINKS.certs});
  y+=4;

  /* 6 — installation summary */
  h2("Installation summary");
  ["Panels are bonded to a clean, dry, load-bearing wall with panel adhesive.",
   "Joints are filled and sanded on site for a seamless surface.",
   "The finished wall is primed and then painted on site — any colour, with standard wall paints.",
   "Allow the panels a few days on site to acclimatise before installation.",
   "Professional installation is advised."].forEach(function(ln){
    pageBreak(5.4);
    fc(TAUPE); doc.circle(ML+1.1, y-1.1, 0.7, "F");
    doc.setFont("helvetica","normal"); doc.setFontSize(9); tc(INK);
    doc.text(ln, ML+4.5, y);
    y+=4.8;
  });

  /* contact footer — bottom of the final page */
  var fy=PH-13;
  dc(LINE); doc.setLineWidth(0.3); doc.line(ML, fy-4.6, ML+CW, fy-4.6);
  doc.setFont("helvetica","normal"); doc.setFontSize(8.5); tc(GREY);
  doc.text("Kandes - Swiss brand · 3D gypsum wall panels", ML, fy);
  // Partner edition: the contact line belongs to the store hosting the planner -
  // leads and follow-up stay with the partner, never with Kandes.
  var l2=window.location.host+window.location.pathname.replace(/\/$/,""), l1=CONTACT_EMAIL;
  var w2=doc.getTextWidth(l2), sep=4;
  tc(MAUVE);
  doc.textWithLink(l2, ML+CW-w2, fy, {url:window.location.origin+window.location.pathname});
  if(l1){
    var w1=doc.getTextWidth(l1);
    tc(GREY); doc.text("·", ML+CW-w2-sep/2-1.2, fy);
    tc(MAUVE);
    doc.textWithLink(l1, ML+CW-w2-sep-w1-2.4, fy, {url:"mailto:"+l1});
  }

  var modelSlug=m.name.split(" — ")[0].replace(/[^A-Za-z0-9]+/g,"-").replace(/^-+|-+$/g,"");
  var fname="Kandes-Wall-Dossier-"+modelSlug+"-"+kwpDateISO()+".pdf";
  if(window.__KWP_DOSSIER_CAPTURE){
    window.__KWP_DOSSIER_DATA=doc.output("datauristring");
    window.__KWP_DOSSIER_NAME=fname;
    return;
  }
  doc.save(fname);
}

function bindDossier(){
  var btn=$("kwp_dossier"); if(!btn) return;
  btn.addEventListener("click", function(){
    if(btn.disabled || btn.getAttribute("data-busy")) return;
    var idle=btn.textContent;
    btn.setAttribute("data-busy","1"); btn.textContent="Preparing…";
    trackEvent("dossier_download");
    Promise.all([kwpLoadJsPDF(), kwpFetchLogo(), captureAllWalls()])
      .then(function(res){ return kwpComposeDossier(res[0], res[1], res[2]); })
      .then(function(){ kwpToolMsg("Your wall dossier is downloading."); })
      .catch(function(){ kwpToolMsg("The dossier could not be generated — please try again, or request a quote and we will include the layout drawing."); })
      .then(function(){ btn.removeAttribute("data-busy"); btn.textContent=idle; });
  });
}

/* =============== Wiring =============== */
function renderAll(){ renderModelMeta(); renderWallTabs(); renderOpenings(); renderFill(); renderMix(); renderLed(); renderAccessories(); renderPreview(); renderSummary(); }

[["kwp_ww","w"],["kwp_wh","h"]].forEach(([id,key])=>{
  $(id).addEventListener("input",e=>{ const w=S.walls[S.active]; w[key]=parseFloat(e.target.value)||0;
    w.open.forEach(o=>clampOpening(w,o)); w.cosmic.placed=null; w.sr.arr={}; w.sr.rot={}; clearCellMaps(w);
    renderFill(); renderMix(); renderPreview(); renderSummary(); });
});
$("kwp_skirt").addEventListener("input",e=>{ S.skirt=parseFloat(e.target.value)||0; S.walls.forEach(w=>{ w.cosmic.placed=null; clearCellMaps(w); }); renderFill(); renderMix(); renderPreview(); renderSummary(); });
$("kwp_addopening").addEventListener("click",()=>{
  const w=S.walls[S.active]; if(w.open.length>=3) return;
  const o={w:0.9,h:2.1,x:Math.max(0,((+w.w||2)-0.9)/2),y:Math.max(0,(+w.h||2.1)-2.1)};
  clampOpening(w,o); w.open.push(o); w.cosmic.placed=null; clearCellMaps(w); renderAll();
});
$("kwp_spill").addEventListener("change",e=>{ S.spill=e.target.checked; renderSummary(); });
[["kwp_alignH","alignH"],["kwp_alignV","alignV"]].forEach(([id,key])=>{
  $(id).querySelectorAll("button").forEach(b=>b.addEventListener("click",()=>{
    S[key]=b.dataset.v;
    $(id).querySelectorAll("button").forEach(x=>x.classList.toggle("on",x===b));
    S.walls.forEach(w=>{ w.cosmic.placed=null; clearCellMaps(w); });
    renderMix(); renderPreview(); renderSummary();
  }));
});
bindCombo();
bindForm();
bindShare();
bindDossier();
renderAll();
// After Shopify's contact redirect the section renders #kwp_posted: show the
// success column; the share fragment (return_to) has already restored the wall.
if(document.getElementById("kwp_posted")){
  $("kwp_inputcol").classList.add("hidden");
  $("kwp_formcol").classList.add("hidden");
  $("kwp_successcol").classList.remove("hidden");
  try{
    var pt=totals();
    if(S.model && pt.valid) $("kwp_succ_sum").textContent = pt.finalN+" × "+S.model.name.split(" — ")[0];
  }catch(e){}
  $("kwp_gotoquote").disabled=true;
  $("kwp_gotoquote").textContent="Quote requested ✓";
  ROOT.scrollIntoView({behavior:"smooth", block:"start"});
}
}
if(document.readyState==="loading") document.addEventListener("DOMContentLoaded", init);
else init();
})();
